export const LABELS_LANGUAGES = {
  es: {
      clavePinQr: {
        title: "Identifícate con Cl@ve",
        scanInstructions: "Escanea este código QR con la app de Cl@ve para autorizar el acceso.",
        mobileInstructions: "Abre la app de Cl@ve para autorizar el acceso.",
        openApp: "Accede a la APP Cl@ve",
        fallbackSms: "No tengo la app de Cl@ve. Continuar por SMS",
        connecting: "Conectando con Cl@ve…",
        gettingQr: "Obteniendo QR",
        timeoutTitle: "El tiempo de espera ha finalizado",
        timeoutText: "No se ha detectado la autorización en la app de Cl@ve.",
        retry: "Reintentar",
        confirmed: "Autorización confirmada. Continuando…",
        dataTitle: "Necesitamos algunos datos",
        dataText: "Introduce tu documento para continuar por SMS.",
        imagesTitle: 'Códigos QR de Cl@ve', verificationCode: 'Código de verificación', imageLoading: 'Cargando código QR', imageError: 'No se pudo cargar este código QR.',
        variants: { oficial: 'Oficial', nobrand: 'Sin marca', deeplink: 'Enlace directo' }, imageAlts: { oficial: 'Código QR oficial de Cl@ve', nobrand: 'Código QR de Cl@ve sin marca', deeplink: 'Código QR de enlace directo de Cl@ve' },
      },
      nie: 'NIE',
      dni: 'DNI',
      nieOrDni: 'DNI o NIE',
      birthday: 'Fecha de nacimiento',
      expiration: 'Fecha de vencimiento del DNI',
      support: 'Código de soporte',
      phone: 'Teléfono',
      email: 'Email',
      inputEmail: 'Ingresa tu email',
      findExpiration: '¿Dónde la encuentro?',
      send: 'Enviar',
      unknownState: 'Estado desconocido',
      manual: 'Ingresar manualmente',

      naturalPerson: 'Persona física',
      legalPerson: 'Persona jurídica',
      cif: 'CIF',

      warnings: {
        error: 'Error!',
        invalidDni: 'Debes ingresar un DNI válido!',
        invalidNie: 'Debes ingresar un NIE válido!',
        invalidNieOrDni: 'Debes ingresar un DNI o NIE válido!',
        errorSomeData: 'Error en algunos datos',
        noPinService: 'Sin servicio Clave PIN',
        noCirbeService: 'Sin servicio Cirbe',
        noCustomization: 'No se ha configurado la customización del widget para este usuario',
        ocassionalError: 'Estamos detectando errores ocasionales, si no puede completar su solicitud, inténtelo más tarde',
        wrongDni: 'Número de documento incorrecto',
        wrongDniDesc: 'El número de documento ingresado es incorrecto, por favor ingrese otro',
        wrongDate: "Fecha incorrecta",
        wrongDateDesc: "La fecha es incorrecta. Revísalo, por favor",
        wrongSupport: 'Número de soporte inválido!',
        inputSupport: 'Por favor, introduce el código de soporte',
        unknownError: 'Error desconocido: ',
        noSms: 'Sin servicio SMS',
        noSmsDesc: 'El usuario no tiene servicio de SMS, vamos a intentar ingresar por flujo Clave Pin, por favor, rellene los campos necesarios',
        noOtp: 'Todavía no has recibido el OTP. Inténtalo de nuevo cuando lo recibas',
        wrongOtp: 'Código inválido. Por favor, introduzca el código recibido por SMS',
        haveToReadTerms: 'Debes leer los términos y condiciones para poder continuar',
        haveToAcceptPolicy: 'Debes aceptar la política de privacidad para poder continuar',
        haveToAcceptAssignment: 'Debes aceptar la cesión de datos para poder continuar',
        phoneError: 'Error con el teléfono',
        dontHavePhone: 'No tengo otro teléfono',
        badPhoneSS: 'El teléfono ingresado no coincide con registrado en la Seguridad Social, por favor ingrese otro',
        wrongBirthday: 'Fecha de nacimiento incorrecta',
        inputBirthDay: 'Por favor, introduce la fecha de nacimiento',
        wrongExpiration: 'Fecha de vencimiento incorrecta',
        inputExpiration: 'Por favor, introduce la fecha de vencimiento del documento',
        duplicatedRequest: 'Solicitud duplicada!',
        alreadyHaveRequest: 'Ya existe una solicitud para este cliente.',
        currentRequestStatus: 'Estado de la solicitud actual: ',
        requestNoExist: 'No existe la solicitud',
        noRequests: 'No existen solicitudes activas con el código requerido',
        needMoreData: 'Necesitamos más datos para validar el acceso a las administraciones públicas',
        needDNI: 'El DNI o NIE es obligatorio',
        needExpirationDate: 'La fecha de vencimiento es obligatoria',
        needBirthDate: 'La fecha de nacimiento es obligatoria',
        needSupportNumber: 'El número de soporte es obligatorio',
        needPhone: 'El teléfono es obligatorio',
        phoneDigitsRequired: 'El teléfono debe tener 9 dígitos',
        invalidDateFormat: 'El formato debe ser DD/MM/AAAA',
        invalidDate: 'Fecha inválida',
        underAge: 'Debe ser mayor de 18 años',
        requiredEmail: 'El email es obligatorio',
        invalidEmail: 'El email no es válido',
        needDate: 'La fecha es obligatoria',
        undefinedError: 'Error indefinido',
        requiredName: 'El nombre es obligatorio',
        requiredFirstSurname: 'El primer apellido es obligatorio',
        requiredSecondSurname: 'El segundo apellido es obligatorio',
        requiredCompanyName: 'La razón social es obligatoria',
        requiredCIF: 'El CIF es obligatorio',
        selectPersonType: 'Debes seleccionar un tipo de persona',
        readAndAcceptBothTerms: 'Debes leer y aceptar ambos términos y condiciones para poder continuar',
        acceptPowerTerms: 'Debes aceptar los términos de poder digital',
      },
      abandoned: {
      afterWaitingAcceptanceFileSigned: 'Abandonado durante la firma del fichero de aceptación',
      afterWaitingOtpSS: 'Abandonado después de esperar OTP de Seguridad Social',
      afterInvalidOtpSS: 'Abandonado despues de OTP inválido en Seguridad Social',
      afterInvalidOtpAEAT: 'Abandonado despues de OTP inválido en AEAT',
      afterWaitingOtpAEAT: 'Abandonado después de esperar OTP de AEAT'
      },
      loadings: {
      gettingData: 'Obteniendo datos de la solicitud...',
      resendingOtp: 'Reenviando OTP...',
      sendingData: 'Enviando datos..',
      validatingData: 'Validando nuevos datos, espere por favor..',
      validatingAndLoginSS: 'Validando datos y logueandose a Seguridad Social, espere por favor..',
      validatingAndLoginAEAT: 'Validando datos y logueandose a AEAT, espere por favor..',
      resendingRequest: 'Reintentando enviar la solicitud...',
      smsToPin: 'Se ha detectado un número de teléfono incorrecto, vamos a probar por flujo Clave PIN',
      sendingNewPhone: 'Enviando nuevo teléfono, aguarde por favor',
      validatingRequest: 'Validando solicitud, espere por favor..',
      creatingRequest: 'Creando solicitud, espere',
      cancelingRequest: 'Cancelando solicitud...',
      checkingSms: 'Verificando servicio SMS..',
      loadingDocs: 'Cargando documentos',
      autoUploadTitle: 'Subida automática de los docs',
      },
      actions: {
      continue: 'Continuar',
      cancel: 'Cancelar proceso',
      back: 'Volver',
      send: 'Enviar',
      retry: 'Intentarlo nuevamente',
      resend: 'Reenviar',
      next: 'Siguiente',
      clickToFinish: 'Haga click aquí para finalizar',
      newRequest: 'Nueva solicitud',
      gotoCurrentRequest: 'Ir a la solicitud actual',
      uploadFiles: 'Subir archivos',
      },
      otp: {
      requestingOtp: 'Estamos solicitando el código. Por favor, espere un momento.',
      otpSentToNumber: 'El código ha sido enviado al teléfono acabado en',
      requestingCode: 'Estamos solicitando el código. Por favor, espere un momento.',
      noReceivedCode: '¿No has recibido el código en tu teléfono?',
      noReceivedCode2: '¿No has recibido el código en el teléfono acabado en',
      otpCode: 'Código OTP (recibido por SMS)'
      },
      certificate: {
        mobileOnlyTitle: 'Uso exclusivo en ordenadores o portátiles',
        mobileOnlyLine1: 'Para garantizar la correcta finalización de este proceso, el acceso está habilitado únicamente desde',
        mobileOnlyDevices: 'ordenadores de sobremesa o portátiles.',
        mobileOnlyLine2: 'Actualmente, el servicio no es compatible con dispositivos móviles o tablets. Te recomendamos que vuelvas a iniciar el proceso desde un ordenador o portátil.',
        responsibleName: 'Nombre de la persona responsable',
        firstSurname: 'Primer apellido de la persona responsable',
        secondSurname: 'Segundo apellido de la persona responsable',
        idDocumentNumber: 'Número de documento de identificación',
        companyName: 'Razón social',
        dniPlaceholder: 'Ej: 12345678R',
        companyPlaceholder: 'Ej: Mi Empresa',
        cifPlaceholder: 'Ej: B12345678',
        idFrontUpload: 'Anverso documento de identificación (Max 2MB)',
        idBackUpload: 'Reverso documento de identificación (Max 2MB)',
        acceptedDocumentsTitle: "Documentos de identificación admitidos",
        acceptedDocumentsDni: "(anverso y reverso)",
        acceptedDocumentsTie: "(anverso y reverso). Documento NIE con fotografía",
        acceptedDocumentsPassport: "Pasaporte + Certificado de asignación de NIE / Tarjeta Verde",
        acceptedDocumentsBothRequired: "(es requerido enviar ambos)",
        acceptedDocumentsFormats: 'PDF, JPG, PNG',
        acceptedDocumentsFormatsLabel: "Formatos permitidos:",
        acceptedDocumentsMaxSizeLabel: "Tamaño máximo por archivo:",
        acceptedDocumentsFilesNote: "Puedes subir los dos archivos correspondientes al tipo de documento.",
        powerConsentBefore: 'Consiento expresamente a la activación de un poder digital según las condiciones que pueden verse ',
        powerConsentHere: 'aquí',
        powerTitle: 'Activar un poder digital',
        powerDescription: 'Vamos a emitir un poder digital a favor de EJEMPLO para poder obtener la documentación necesaria en solicitudes de financiación. Para poder actualizar tu información, siempre te volveremos a pedir el consentimiento.',
        powerAcceptSign: 'Acepto y firmo digitalmente el documento',
        powerTcTitle: 'OTORGAR UN PODER DIGITAL PARA OBTENER LA DOCUMENTACIÓN AUTOMÁTICAMENTE',
        requestAgainIn: 'Solicítalo de nuevo en',
        seconds: 'segundos',
        status: 'Estado',
        createNewRequest: 'Crear nueva solicitud',
        noAutofirmaHint: 'Si no tiene <strong>Autofirma</strong> instalado, accede al siguiente enlace para <a href="https://firmaelectronica.gob.es/Home/Descargas.html" class="text-blue-500 font-bold underline" target="_blank">Instalar Autofirma</a>',
        password: {
          label: 'Contraseña',
          confirmLabel: 'Repite Contraseña',
          required: 'La contraseña es requerida',
          minLength: 'La contraseña debe tener al menos 8 carácteres',
          confirmRequired: 'Es necesario repetir la contraseña',
          mismatch: 'Las contraseñas deben coincidir',
          save: 'Guardar',
        },
        autofirma: {
          signedFileLoaded: 'Archivo firmado cargado',
          signCertificate: 'Firmar certificado',
          waitingAutofirma: 'Esperando autofirma...',
          noDocument: 'No hay documento para enviar.',
          prepareError: 'No se pudo preparar el documento: ',
          notFoundTitle: 'No se encuentra AutoFirma',
          notFoundMessage: 'No hemos detectado que Autofirma esté instalado en su equipo. Por favor utilice el siguiente enlace para descargarlo y vuelva a intentarlo.',
          timeoutMessage: 'No se ha recibido respuesta de AutoFirma. Compruebe que la aplicación está instalada y que el navegador puede abrirla, e inténtelo de nuevo. Si aún no la tiene, puede descargarla desde el siguiente enlace.',
          downloadAutofirma: 'Descargar Autofirma',
          cancel: 'Cancelar',
          unknownError: 'No se puede completar la firma',
          errorOccurred: 'Ha ocurrido un error: ',
        },
        errors: {
          readServiceTerms: 'Debe leer los términos y condiciones del servicio',
          readCertTerms: 'Debe leer los términos y condiciones para la emisión de certificado',
          acceptServiceTerms: 'Debe aceptar los términos y condiciones del servicio',
          acceptSecurityPolicy: 'Debe aceptar la política de seguridad',
          acceptCertTerms: 'Debe aceptar los términos y condiciones para la emisión de certificado',
          acceptLegalCheck: 'Debe aceptar el check legal',
          consentPowerActivation: 'Debe consentir la activación de un poder digital registrado en el REA',
        },
        loadings: {
          gettingRequestInfo: 'Obteniendo información de la solicitud',
          uploadingDocs: 'Subiendo documentación...',
          sendingInfo: 'Enviando información..',
          startingEmission: 'Iniciando el proceso de emisión de certificado..',
          validatingInfo: 'Validando información, espere por favor..',
          sendingOtp: 'Enviando código OTP ..',
          processingRequest: 'Estamos procesando su solicitud. Espere un momento por favor',
        },
        requestRetry: {
          title: 'Error con la solicitud',
          description: 'Esta solicitud se encuentra en estado suspendida y ha sido reemplazada por otra mas reciente, si lo desea, puede continuar el flujo con esa solicitud haciendo click en el botón a continuación',
          continueFlow: 'Continuar flujo',
        },
        requisites: {
          haveFde: 'Tengo FDE instalado, continuar',
          noFde: 'No tengo FDE instalado, instalar',
          downloadStore: 'Descargar desde Microsoft Store',
          fdeOpened: 'Ya se abrió FDE, continuar',
        },
      },
      flowCommon: {
        personType: 'Tipo de persona',
        natural: 'Natural',
        legal: 'Legal',
        name: 'Nombre',
        firstSurname: 'Primer apellido',
        secondSurname: 'Segundo apellido',
        emailPlaceholder: 'Ej: mi_email@dominio.com',
        phonePlaceholder: 'Ej: 123123123',
        dniPlaceholderShort: 'Ej: 2222221R',
        cifPlaceholderShort: 'Ej: 123123123',
        certTermsBefore: 'He leído y acepto los',
        certTermsLink: 'términos y condiciones',
        certTermsAfter: 'para la emisión del certificado',
        loadingData: 'Cargando datos..',
        sendingPassword: 'Enviando contraseña..',
      },
      videoid: {
        waitingVideoId: 'Aguardando validación por Video ID',
        redirectingVintegris: 'Redirigiendo a Vintegris, aguarde por favor...',
        sendingPassword: 'Enviando password..',
        sendingOtpShort: 'Enviando OTP..',
        invalidOtpRetry: 'El código introducido no es correcto. Por favor, inténtelo de nuevo',
      },
  },
  en: {
      clavePinQr: {
        title: "Identify with Cl@ve",
        scanInstructions: "Scan this QR code with the Cl@ve app to authorize access.",
        mobileInstructions: "Open the Cl@ve app to authorize access.",
        openApp: "Open the Cl@ve app",
        fallbackSms: "I don't have the Cl@ve app. Continue by SMS",
        connecting: "Connecting with Cl@ve…",
        gettingQr: "Getting QR",
        timeoutTitle: "The waiting time has expired",
        timeoutText: "No authorization was detected in the Cl@ve app.",
        retry: "Retry",
        confirmed: "Authorization confirmed. Continuing…",
        dataTitle: "We need some details",
        dataText: "Enter your ID document to continue by SMS.",
        imagesTitle: 'Cl@ve QR codes', verificationCode: 'Verification code', imageLoading: 'Loading QR code', imageError: 'This QR code could not be loaded.',
        variants: { oficial: 'oficial', nobrand: 'No branding', deeplink: 'Direct link' }, imageAlts: { oficial: 'oficial Cl@ve QR code', nobrand: 'Unbranded Cl@ve QR code', deeplink: 'Cl@ve direct-link QR code' },
      },
    nie: 'NIE',
    dni: 'DNI',
    nieOrDni: 'DNI or NIE',
    birthday: 'Date of birth',
    expiration: 'ID expiration date',
    support: 'Support code',
    phone: 'Phone',
    email: 'Email',
    inputEmail: 'Enter your email',
    findExpiration: 'Where can I find it?',
    send: 'Send',
    unknownState: 'Unknown status',
    manual: 'Enter manually',

    naturalPerson: 'Natural person',
    legalPerson: 'Legal entity',
    cif: 'CIF',

    warnings: {
      error: 'Error!',
      invalidDni: 'You must enter a valid DNI!',
      invalidNie: 'You must enter a valid NIE!',
      invalidNieOrDni: 'You must enter a valid DNI or NIE!',
      errorSomeData: 'Error in some data',
      noPinService: 'No Clave Pin service',
      noCirbeService: 'No Cirbe service',
      noCustomization: 'The widget customization has not been configured for this user',
      ocassionalError: 'We are detecting occasional errors; if you cannot complete your request, please try again later',
      wrongDni: 'Incorrect document number',
      wrongDniDesc: 'The entered document number is incorrect, please enter another one',
      wrongDate: 'Incorrect date',
      wrongDateDesc: 'The date is incorrect. Please check it',
      wrongSupport: 'Invalid support number!',
      inputSupport: 'Please enter the support code',
      unknownError: 'Unknown error: ',
      noSms: 'No SMS service',
      noSmsDesc: 'The user has no SMS service; we will try to access through the Clave PIN flow. Please fill in the required fields',
      noOtp: 'You have not received the OTP yet. Try again when you receive it',
      wrongOtp: 'Invalid code. Please enter the code received by SMS',
      haveToReadTerms: 'You must read the terms and conditions to continue',
      haveToAcceptPolicy: 'You must accept the privacy policy to continue',
      haveToAcceptAssignment: 'You must accept the data assignment to continue',
      phoneError: 'Phone error',
      dontHavePhone: 'I don’t have another phone',
      badPhoneSS: 'The entered phone number does not match the one registered with Social Security, please enter another one',
      wrongBirthday: 'Incorrect date of birth',
      inputBirthDay: 'Please enter the date of birth',
      wrongExpiration: 'Incorrect expiration date',
      inputExpiration: 'Please enter the document expiration date',
      duplicatedRequest: 'Duplicate request!',
      alreadyHaveRequest: 'A request already exists for this client.',
      currentRequestStatus: 'Current request status: ',
      requestNoExist: 'The request does not exist',
      noRequests: 'There are no active requests with the required code',
      needMoreData: 'We need more data to validate access to public administrations',
      needDNI: 'The DNI or NIE is required',
      needExpirationDate: 'The expiration date is required',
      needBirthDate: 'The date of birth is required',
      needSupportNumber: 'The support number is required',
      needPhone: 'The phone number is required',
      phoneDigitsRequired: 'The phone number must have 9 digits',
      invalidDateFormat: 'The format must be DD/MM/YYYY',
      invalidDate: 'Invalid date',
      underAge: 'Must be 18 years or older',
      requiredEmail: 'The email is required',
      invalidEmail: 'The email is not valid',
      needDate: 'The date is required',
      undefinedError: 'Undefined error',
      requiredName: 'The first name is required',
      requiredFirstSurname: 'The first surname is required',
      requiredSecondSurname: 'The second surname is required',
      requiredCompanyName: 'The company name is required',
      requiredCIF: 'The CIF is required',
      selectPersonType: 'You must select a person type',
      readAndAcceptBothTerms: 'You must read and accept both terms and conditions to continue',
      acceptPowerTerms: 'You must accept the digital power terms',
    },
    abandoned: {
      afterWaitingAcceptanceFileSigned: 'Abandoned while signing the acceptance file',
      afterWaitingOtpSS: 'Abandoned after waiting for Social Security OTP',
      afterInvalidOtpSS: 'Abandoned after invalid OTP in Social Security',
      afterInvalidOtpAEAT: 'Abandoned after invalid OTP in AEAT',
      afterWaitingOtpAEAT: 'Abandoned after waiting for AEAT OTP',
    },
    loadings: {
      gettingData: 'Retrieving request data...',
      resendingOtp: 'Resending OTP...',
      sendingData: 'Sending data...',
      validatingData: 'Validating new data, please wait...',
      validatingAndLoginSS: 'Validating data and logging into Social Security, please wait...',
      validatingAndLoginAEAT: 'Validating data and logging into AEAT, please wait...',
      resendingRequest: 'Retrying to submit the request...',
      smsToPin: 'An incorrect phone number was detected; we are going to try the Clave PIN flow',
      sendingNewPhone: 'Sending new phone number, please wait',
      validatingRequest: 'Validating request, please wait...',
      creatingRequest: 'Creating request, please wait',
      cancelingRequest: 'Cancelling request...',
      checkingSms: 'Checking SMS service...',
      loadingDocs: 'Loading documents',
      autoUploadTitle: 'Automatic document upload',
    },
    actions: {
      continue: 'Continue',
      cancel: 'Cancel process',
      back: 'Back',
      send: 'Send',
      retry: 'Try again',
      resend: 'Resend',
      next: 'Next',
      clickToFinish: 'Click here to finish',
      newRequest: 'New request',
      gotoCurrentRequest: 'Go to current request',
      uploadFiles: 'Upload files',
    },
    otp: {
      requestingOtp: 'We are requesting the code. Please wait a moment.',
      otpSentToNumber: 'The code has been sent to the phone ending in',
      requestingCode: 'We are requesting the code. Please wait a moment.',
      noReceivedCode: 'Didn’t receive the code on your phone?',
      noReceivedCode2: 'Didn’t receive the code on the phone ending in',
      otpCode: 'OTP code (received by SMS)'
    },
    certificate: {
      mobileOnlyTitle: 'Desktop or laptop use only',
      mobileOnlyLine1: 'To ensure this process completes correctly, access is enabled only from',
      mobileOnlyDevices: 'desktop or laptop computers.',
      mobileOnlyLine2: 'This service is not currently compatible with mobile devices or tablets. Please restart the process from a desktop or laptop.',
      responsibleName: 'Name of the responsible person',
      firstSurname: 'First surname of the responsible person',
      secondSurname: 'Second surname of the responsible person',
      idDocumentNumber: 'Identification document number',
      companyName: 'Company name',
      dniPlaceholder: 'E.g.: 12345678R',
      companyPlaceholder: 'E.g.: My Company',
      cifPlaceholder: 'E.g.: B12345678',
      idFrontUpload: 'Front of identification document (Max 2MB)',
      idBackUpload: 'Back of identification document (Max 2MB)',
      acceptedDocumentsTitle: "Accepted identification documents",
      acceptedDocumentsDni: "(front and back)",
      acceptedDocumentsTie: "(front and back). NIE document with a photograph",
      acceptedDocumentsPassport: "Passport + NIE assignment certificate / Green Card",
      acceptedDocumentsBothRequired: "(both are required)",
      acceptedDocumentsFormats: 'PDF, JPG, PNG',
      acceptedDocumentsFormatsLabel: "Accepted formats:",
      acceptedDocumentsMaxSizeLabel: "Maximum size per file:",
      acceptedDocumentsFilesNote: "You can upload the two files corresponding to the document type.",
      powerConsentBefore: 'I expressly consent to the activation of a digital power according to the conditions that can be viewed ',
      powerConsentHere: 'here',
      powerTitle: 'Activate a digital power',
      powerDescription: 'We are going to issue a digital power in favor of EJEMPLO to obtain the necessary documentation in financing requests. To update your information, we will always ask for your consent again.',
      powerAcceptSign: 'I accept and digitally sign the document',
      powerTcTitle: 'GRANT A DIGITAL POWER TO OBTAIN DOCUMENTATION AUTOMATICALLY',
      requestAgainIn: 'Request it again in',
      seconds: 'seconds',
      status: 'Status',
      createNewRequest: 'Create new request',
      noAutofirmaHint: 'If you do not have <strong>Autofirma</strong> installed, use the following link to <a href="https://firmaelectronica.gob.es/Home/Descargas.html" class="text-blue-500 font-bold underline" target="_blank">Install Autofirma</a>',
      password: {
        label: 'Password',
        confirmLabel: 'Repeat password',
        required: 'Password is required',
        minLength: 'Password must be at least 8 characters',
        confirmRequired: 'You must repeat the password',
        mismatch: 'Passwords must match',
        save: 'Save',
      },
      autofirma: {
        signedFileLoaded: 'Signed file uploaded',
        signCertificate: 'Sign certificate',
        waitingAutofirma: 'Waiting for Autofirma...',
        noDocument: 'There is no document to send.',
        prepareError: 'Could not prepare the document: ',
        notFoundTitle: 'Autofirma not found',
        notFoundMessage: 'We have not detected Autofirma installed on your device. Please use the following link to download it and try again.',
        timeoutMessage: 'No response was received from Autofirma. Check that the application is installed and that the browser can open it, then try again. If you do not have it yet, you can download it from the following link.',
        downloadAutofirma: 'Download Autofirma',
        cancel: 'Cancel',
        unknownError: 'Unknown error',
        errorOccurred: 'An error occurred: ',
      },
      errors: {
        readServiceTerms: 'You must read the service terms and conditions',
        readCertTerms: 'You must read the terms and conditions for certificate issuance',
        acceptServiceTerms: 'You must accept the service terms and conditions',
        acceptSecurityPolicy: 'You must accept the security policy',
        acceptCertTerms: 'You must accept the terms and conditions for certificate issuance',
        acceptLegalCheck: 'You must accept the legal checkbox',
        consentPowerActivation: 'You must consent to the activation of a digital power registered in the REA',
      },
        loadings: {
          gettingRequestInfo: 'Retrieving request information',
          uploadingDocs: 'Uploading documentation...',
          sendingInfo: 'Sending information...',
          startingEmission: 'Starting certificate issuance process...',
          validatingInfo: 'Validating information, please wait...',
          sendingOtp: 'Sending OTP code...',
          processingRequest: 'We are processing your request. Please wait a moment',
        },
        requestRetry: {
          title: 'Request error',
          description: 'This request is suspended and has been replaced by a more recent one. If you wish, you can continue the flow with that request by clicking the button below',
          continueFlow: 'Continue flow',
        },
        requisites: {
          haveFde: 'I have FDE installed, continue',
          noFde: "I don't have FDE installed, install",
          downloadStore: 'Download from Microsoft Store',
          fdeOpened: 'FDE is now open, continue',
        },
    },
    flowCommon: {
      personType: 'Person type',
      natural: 'Natural',
      legal: 'Legal',
      name: 'First name',
      firstSurname: 'First surname',
      secondSurname: 'Second surname',
      emailPlaceholder: 'E.g.: my_email@domain.com',
      phonePlaceholder: 'E.g.: 123123123',
      dniPlaceholderShort: 'E.g.: 2222221R',
      cifPlaceholderShort: 'E.g.: 123123123',
      certTermsBefore: 'I have read and accept the',
      certTermsLink: 'terms and conditions',
      certTermsAfter: 'for certificate issuance',
      loadingData: 'Loading data...',
      sendingPassword: 'Sending password...',
    },
    videoid: {
      waitingVideoId: 'Waiting for Video ID validation',
      redirectingVintegris: 'Redirecting to Vintegris, please wait...',
      sendingPassword: 'Sending password...',
      sendingOtpShort: 'Sending OTP...',
      invalidOtpRetry: 'The entered code is incorrect. Please try again',
    },
  },
  ca: {
      clavePinQr: {
        title: "Identifica't amb Cl@ve",
        scanInstructions: "Escaneja aquest codi QR amb l'app de Cl@ve per autoritzar l'accés.",
        mobileInstructions: "Obre l'app de Cl@ve per autoritzar l'accés.",
        openApp: "Obrir l'app de Cl@ve",
        fallbackSms: "No tinc l'app de Cl@ve. Continuar per SMS",
        connecting: "Connectant amb Cl@ve…",
        gettingQr: "Obtenint QR",
        timeoutTitle: "El temps d'espera ha finalitzat",
        timeoutText: "No s'ha detectat l'autorització a l'app de Cl@ve.",
        retry: "Tornar-ho a provar",
        confirmed: "Autorització confirmada. Continuant…",
        dataTitle: "Necessitem algunes dades",
        dataText: "Introdueix el teu document per continuar per SMS.",
        imagesTitle: 'Codis QR de Cl@ve', verificationCode: 'Codi de verificació', imageLoading: 'Carregant codi QR', imageError: 'No s’ha pogut carregar aquest codi QR.',
        variants: { oficial: 'Oficial', nobrand: 'Sense marca', deeplink: 'Enllaç directe' }, imageAlts: { oficial: 'Codi QR oficial de Cl@ve', nobrand: 'Codi QR de Cl@ve sense marca', deeplink: 'Codi QR d’enllaç directe de Cl@ve' },
      },
    nie: 'NIE',
    dni: 'DNI',
    nieOrDni: 'DNI o NIE',
    birthday: 'Data de naixement',
    expiration: 'Data de caducitat del DNI',
    support: 'Codi de suport',
    phone: 'Telèfon',
    email: 'Correu electrònic',
    inputEmail: 'Introdueix el teu correu electrònic',
    findExpiration: 'On la trobo?',
    send: 'Enviar',
    unknownState: 'Estat desconegut',
    manual: 'Introduir manualment',

    naturalPerson: 'Persona física',
    legalPerson: 'Persona jurídica',
    cif: 'CIF',

    warnings: {
      error: 'Error!',
      invalidDni: 'Has d\'introduir un DNI vàlid!',
      invalidNie: 'Has d\'introduir un NIE vàlid!',
      invalidNieOrDni: 'Has d\'introduir un DNI o NIE vàlid!',
      errorSomeData: 'Error en algunes dades',
      noPinService: 'Sense servei Clave PIN',
      noCirbeService: 'Sin servicio Cirbe',
      noCustomization: 'No s\'ha configurat la personalització del widget per a aquest usuari',
      ocassionalError: 'Estem detectant errors ocasionals; si no pots completar la teva sol·licitud, torna-ho a intentar més tard',
      wrongDni: 'Número de document incorrecte',
      wrongDniDesc: 'El número de document introduït és incorrecte, si us plau, introdueix-ne un altre',
      wrongDate: 'Data incorrecta',
      wrongDateDesc: 'La data és incorrecta. Revisa-la, si us plau',
      wrongSupport: 'Número de suport no vàlid!',
      inputSupport: 'Si us plau, introdueix el codi de suport',
      unknownError: 'Error desconegut: ',
      noSms: 'Sense servei SMS',
      noSmsDesc: 'L\'usuari no té servei d\'SMS; intentarem accedir pel flux Clave PIN. Si us plau, omple els camps necessaris',
      noOtp: 'Encara no has rebut l’OTP. Torna-ho a intentar quan el rebis',
      wrongOtp: 'Codi no vàlid. Si us plau, introdueix el codi rebut per SMS',
      haveToReadTerms: 'Has de llegir els termes i condicions per poder continuar',
      haveToAcceptPolicy: 'Has d\'acceptar la política de privacitat per poder continuar',
      haveToAcceptAssignment: 'Has d\'acceptar la cessió de dades per poder continuar',
      phoneError: 'Error amb el telèfon',
      dontHavePhone: 'No tinc un altre telèfon',
      badPhoneSS: 'El telèfon introduït no coincideix amb el registrat a la Seguretat Social, si us plau, introdueix-ne un altre',
      wrongBirthday: 'Data de naixement incorrecta',
      inputBirthDay: 'Si us plau, introdueix la data de naixement',
      wrongExpiration: 'Data de caducitat incorrecta',
      inputExpiration: 'Si us plau, introdueix la data de caducitat del document',
      duplicatedRequest: 'Sol·licitud duplicada!',
      alreadyHaveRequest: 'Ja existeix una sol·licitud per a aquest client.',
      currentRequestStatus: 'Estat de la sol·licitud actual: ',
      requestNoExist: 'La sol·licitud no existeix',
      noRequests: 'No hi ha sol·licituds actives amb el codi requerit',
      needMoreData: 'Necessitem més dades per validar l’accés a les administracions públiques',
      needDNI: 'El DNI o NIE és obligatori',
      needExpirationDate: 'La data de caducitat és obligatòria',
      needBirthDate: 'La data de naixement és obligatòria',
      needSupportNumber: 'El número de suport és obligatori',
      needPhone: 'El telèfon és obligatori',
      phoneDigitsRequired: 'El telèfon ha de tenir 9 dígits',
      invalidDateFormat: 'El format ha de ser DD/MM/AAAA',
      invalidDate: 'Data invàlida',
      underAge: 'Ha de ser major de 18 anys',
      requiredEmail: 'El correu electrònic és obligatori',
      invalidEmail: 'El correu electrònic no és vàlid',
      needDate: 'La data és obligatória',
      undefinedError: 'Error indefinit',
      requiredName: 'El nom és obligatori',
      requiredFirstSurname: 'El primer cognom és obligatori',
      requiredSecondSurname: 'El segon cognom és obligatori',
      requiredCompanyName: 'La raó social és obligatória',
      requiredCIF: 'El CIF és obligatori',
      selectPersonType: 'Has de seleccionar un tipus de persona',
      readAndAcceptBothTerms: 'Has de llegir i acceptar tots dos termes i condicions per continuar',
      acceptPowerTerms: 'Has d\'acceptar els termes del poder digital',
    },
    abandoned: {
      afterWaitingAcceptanceFileSigned: 'Abandonat durant la signatura del fitxer d’acceptació',
      afterWaitingOtpSS: 'Abandonat després d’esperar l’OTP de la Seguretat Social',
      afterInvalidOtpSS: 'Abandonat després d’un OTP no vàlid a la Seguretat Social',
      afterInvalidOtpAEAT: 'Abandonat després d’un OTP no vàlid a l’AEAT',
      afterWaitingOtpAEAT: 'Abandonat després d’esperar l’OTP de l’AEAT'
    },
    loadings: {
      gettingData: 'Obtenint dades de la sol·licitud...',
      resendingOtp: 'Reenviant l’OTP...',
      sendingData: 'Enviant dades...',
      validatingData: 'Validant dades noves, espera, si us plau...',
      validatingAndLoginSS: 'Validant dades i iniciant sessió a la Seguretat Social, espera, si us plau...',
      validatingAndLoginAEAT: 'Validant dades i iniciant sessió a l’AEAT, espera, si us plau...',
      resendingRequest: 'Tornant a intentar enviar la sol·licitud...',
      smsToPin: 'S’ha detectat un número de telèfon incorrecte; provarem el flux Clave PIN',
      sendingNewPhone: 'Enviant el nou telèfon, espera, si us plau',
      validatingRequest: 'Validant la sol·licitud, espera, si us plau...',
      creatingRequest: 'Creant la sol·licitud, espera',
      cancelingRequest: 'Cancel·lant la sol·licitud...',
      checkingSms: 'Verificant el servei SMS...',
      loadingDocs: 'Carregant documents',
      autoUploadTitle: 'Pujada automàtica dels documents',
    },
    actions: {
      continue: 'Continuar',
      cancel: 'Cancel·lar el procés',
      back: 'Tornar',
      send: 'Enviar',
      retry: 'Torna-ho a intentar',
      resend: 'Reenviar',
      next: 'Següent',
      clickToFinish: 'Fes clic aquí per finalitzar',
      newRequest: 'Nova sol·licitud',
      gotoCurrentRequest: 'Anar a la sol·licitud actual',
      uploadFiles: 'Pujar fitxers',
    },
    otp: {
      requestingOtp: 'Estem sol·licitant el codi. Si us plau, espera un moment.',
      otpSentToNumber: 'El codi s’ha enviat al telèfon acabat en',
      requestingCode: 'Estem sol·licitant el codi. Si us plau, espera un moment.',
      noReceivedCode: 'No has rebut el codi al teu telèfon?',
      noReceivedCode2: 'No has rebut el codi al telèfon acabat en',
      otpCode: 'Codi OTP (rebut per SMS)'
    },
    certificate: {
      mobileOnlyTitle: 'Ús exclusiu en ordinadors o portàtils',
      mobileOnlyLine1: 'Per garantir la correcta finalització d\'aquest procés, l\'accés està habilitat únicament des de',
      mobileOnlyDevices: 'ordinadors d\'escriptori o portàtils.',
      mobileOnlyLine2: 'Actualment, el servei no és compatible amb dispositius mòbils o tauletes. Et recomanem que tornis a iniciar el procés des d\'un ordinador o portàtil.',
      responsibleName: 'Nom de la persona responsable',
      firstSurname: 'Primer cognom de la persona responsable',
      secondSurname: 'Segon cognom de la persona responsable',
      idDocumentNumber: 'Número de document d\'identificació',
      companyName: 'Raó social',
      dniPlaceholder: 'Ex: 12345678R',
      companyPlaceholder: 'Ex: La meva empresa',
      cifPlaceholder: 'Ex: B12345678',
      idFrontUpload: 'Anvers del document d\'identificació (màx. 2 MB)',
      idBackUpload: 'Revers del document d\'identificació (màx. 2 MB)',
      acceptedDocumentsTitle: "Documents d’identificació admesos",
      acceptedDocumentsDni: "(anvers i revers)",
      acceptedDocumentsTie: "(anvers i revers). Document NIE amb fotografia",
      acceptedDocumentsPassport: "Passaport + Certificat d’assignació de NIE / Targeta Verda",
      acceptedDocumentsBothRequired: "(cal enviar tots dos)",
      acceptedDocumentsFormats: 'PDF, JPG, PNG',
      acceptedDocumentsFormatsLabel: "Formats permesos:",
      acceptedDocumentsMaxSizeLabel: "Mida màxima per fitxer:",
      acceptedDocumentsFilesNote: "Pots pujar els dos fitxers corresponents al tipus de document.",
      powerConsentBefore: 'Consenteixo expressament l\'activació d\'un poder digital segons les condicions que es poden consultar ',
      powerConsentHere: 'aquí',
      powerTitle: 'Activar un poder digital',
      powerDescription: 'Emitirem un poder digital a favor de EJEMPLO per obtenir la documentació necessària en sol·licituds de finançament. Per actualitzar la teva informació, sempre et tornarem a demanar el consentiment.',
      powerAcceptSign: 'Accepto i firmo digitalment el document',
      powerTcTitle: 'OTORGAR UN PODER DIGITAL PER OBTENIR LA DOCUMENTACIÓ AUTOMÀTICAMENTE',
      requestAgainIn: 'Sol·licita-ho de nou en',
      seconds: 'segons',
      status: 'Estat',
      createNewRequest: 'Crear nova sol·licitud',
      noAutofirmaHint: 'Si no tens <strong>Autofirma</strong> instal·lat, accedeix a l’enllaç següent per <a href="https://firmaelectronica.gob.es/Home/Descargas.html" class="text-blue-500 font-bold underline" target="_blank">Instal·lar Autofirma</a>',
      password: {
        label: 'Contrasenya',
        confirmLabel: 'Repeteix la contrasenya',
        required: 'La contrasenya és obligatòria',
        minLength: 'La contrasenya ha de tenir almenys 8 caràcters',
        confirmRequired: 'Cal repetir la contrasenya',
        mismatch: 'Les contrasenyes han de coincidir',
        save: 'Desar',
      },
      autofirma: {
        signedFileLoaded: 'Fitxer signat carregat',
        signCertificate: 'Signar certificat',
        waitingAutofirma: 'Esperant Autofirma...',
        noDocument: 'No hi ha cap document per enviar.',
        prepareError: 'No s\'ha pogut preparar el document: ',
        notFoundTitle: 'No s\'ha trobat Autofirma',
        notFoundMessage: 'No hem detectat Autofirma instal·lat al teu equip. Si us plau, utilitza l\'enllaç següent per descarregar-lo i torna-ho a intentar.',
        timeoutMessage: 'No s\'ha rebut resposta d\'Autofirma. Comprova que l\'aplicació està instal·lada i que el navegador pot obrir-la, i torna-ho a intentar. Si encara no la tens, pots descarregar-la des de l\'enllaç següent.',
        downloadAutofirma: 'Descarregar Autofirma',
        cancel: 'Cancel·lar',
        unknownError: 'Error desconegut',
        errorOccurred: 'S\'ha produït un error: ',
      },
      errors: {
        readServiceTerms: 'Has de llegir els termes i condicions del servei',
        readCertTerms: 'Has de llegir els termes i condicions per a l\'emissió del certificat',
        acceptServiceTerms: 'Has d\'acceptar els termes i condicions del servei',
        acceptSecurityPolicy: 'Has d\'acceptar la política de seguretat',
        acceptCertTerms: 'Has d\'acceptar els termes i condicions per a l\'emissió del certificat',
        acceptLegalCheck: 'Has d\'acceptar el check legal',
        consentPowerActivation: 'Has de consentir l\'activació d\'un poder digital registrat al REA',
      },
      loadings: {
        gettingRequestInfo: 'Obtenint informació de la sol·licitud',
        uploadingDocs: 'Pujant documentació...',
        sendingInfo: 'Enviant informació...',
        startingEmission: 'Iniciant el procés d\'emissió del certificat...',
        validatingInfo: 'Validant informació, espera, si us plau...',
        sendingOtp: 'Enviant codi OTP...',
        processingRequest: 'Estem processant la teva sol·licitud. Espera un moment, si us plau',
      },
      requestRetry: {
        title: 'Error amb la sol·licitud',
        description: 'Aquesta sol·licitud està suspesa i ha estat substituïda per una de més recent. Si ho desitges, pots continuar el flux amb aquesta sol·licitud fent clic al botó següent',
        continueFlow: 'Continuar flux',
      },
      requisites: {
        haveFde: 'Tinc FDE instal·lat, continuar',
        noFde: 'No tinc FDE instal·lat, instal·lar',
        downloadStore: 'Descarregar des de Microsoft Store',
        fdeOpened: 'Ja s\'ha obert FDE, continuar',
      },
    },
    flowCommon: {
      personType: 'Tipus de persona',
      natural: 'Natural',
      legal: 'Jurídica',
      name: 'Nom',
      firstSurname: 'Primer cognom',
      secondSurname: 'Segon cognom',
      emailPlaceholder: 'Ex: el_meu_correu@domini.com',
      phonePlaceholder: 'Ex: 123123123',
      dniPlaceholderShort: 'Ex: 2222221R',
      cifPlaceholderShort: 'Ex: 123123123',
      certTermsBefore: 'He llegit i accepto els',
      certTermsLink: 'termes i condicions',
      certTermsAfter: 'per a l\'emissió del certificat',
      loadingData: 'Carregant dades...',
      sendingPassword: 'Enviant contrasenya...',
    },
    videoid: {
      waitingVideoId: 'Esperant validació per Video ID',
      redirectingVintegris: 'Redirigint a Vintegris, espera, si us plau...',
      sendingPassword: 'Enviant contrasenya...',
      sendingOtpShort: 'Enviant OTP...',
      invalidOtpRetry: 'El codi introduït no és correcte. Si us plau, torna-ho a intentar',
    },
  },
  fr: {
      clavePinQr: {
        title: "Identifiez-vous avec Cl@ve",
        scanInstructions: "Scannez ce code QR avec l'application Cl@ve pour autoriser l'accès.",
        mobileInstructions: "Ouvrez l'application Cl@ve pour autoriser l'accès.",
        openApp: "Ouvrir l'application Cl@ve",
        fallbackSms: "Je n'ai pas l'application Cl@ve. Continuer par SMS",
        connecting: "Connexion à Cl@ve…",
        gettingQr: "Récupération du QR",
        timeoutTitle: "Le temps d'attente est écoulé",
        timeoutText: "Aucune autorisation détectée dans l'application Cl@ve.",
        retry: "Réessayer",
        confirmed: "Autorisation confirmée. Poursuite…",
        dataTitle: "Nous avons besoin de quelques informations",
        dataText: "Saisissez votre pièce d'identité pour continuer par SMS.",
        imagesTitle: 'Codes QR Cl@ve', verificationCode: 'Code de vérification', imageLoading: 'Chargement du code QR', imageError: 'Ce code QR n’a pas pu être chargé.',
        variants: { oficial: 'Officiel', nobrand: 'Sans marque', deeplink: 'Lien direct' }, imageAlts: { oficial: 'Code QR Cl@ve officiel', nobrand: 'Code QR Cl@ve sans marque', deeplink: 'Code QR de lien direct Cl@ve' },
      },
    nie: 'NIE',
    dni: 'DNI',
    nieOrDni: 'DNI ou NIE',
    birthday: 'Date de naissance',
    expiration: "Date d'expiration du DNI",
    support: 'Code de support',
    phone: 'Téléphone',
    email: 'E-mail',
    inputEmail: 'Saisis ton e-mail',
    findExpiration: 'Où la trouver ?',
    send: 'Envoyer',
    unknownState: 'Statut inconnu',
    manual: 'Saisir manuellement',

    naturalPerson: 'Personne physique',
    legalPerson: 'Personne morale',
    cif: 'CIF',

    warnings: {
      error: 'Erreur !',
      invalidDni: 'Tu dois saisir un DNI valide !',
      invalidNie: 'Tu dois saisir un NIE valide !',
      invalidNieOrDni: 'Tu dois saisir un DNI ou NIE valide !',
      errorSomeData: 'Erreur dans certaines données',
      noPinService: 'Sans service Clave PIN',
      noCirbeService: 'Sans service Cirbe',
      noCustomization: "La personnalisation du widget n'a pas été configurée pour cet utilisateur",
      ocassionalError: 'Nous détectons des erreurs occasionnelles ; si tu ne peux pas compléter ta demande, réessaie plus tard',
      wrongDni: 'Numéro de document incorrect',
      wrongDniDesc: 'Le numéro de document saisi est incorrect, merci d’en saisir un autre',
      wrongDate: 'Date incorrecte',
      wrongDateDesc: 'La date est incorrecte. Vérifie-la, s’il te plaît',
      wrongSupport: 'Numéro de support invalide !',
      inputSupport: 'Merci de saisir le code de support',
      unknownError: 'Erreur inconnue : ',
      noSms: 'Sans service SMS',
      noSmsDesc: "L'utilisateur n'a pas de service SMS ; nous allons tenter d'accéder via le flux Clave PIN, merci de remplir les champs requis",
      noOtp: "Tu n'as pas encore reçu l'OTP. Réessaie quand tu l'auras reçu",
      wrongOtp: 'Code invalide. Merci de saisir le code reçu par SMS',
      haveToReadTerms: 'Tu dois lire les termes et conditions pour pouvoir continuer',
      haveToAcceptPolicy: 'Tu dois accepter la politique de confidentialité pour pouvoir continuer',
      haveToAcceptAssignment: 'Tu dois accepter la cession de données pour pouvoir continuer',
      phoneError: 'Erreur avec le téléphone',
      dontHavePhone: "Je n'ai pas d'autre téléphone",
      badPhoneSS: "Le numéro de téléphone saisi ne correspond pas à celui enregistré à la Sécurité sociale, merci d'en saisir un autre",
      wrongBirthday: 'Date de naissance incorrecte',
      inputBirthDay: 'Merci de saisir la date de naissance',
      wrongExpiration: "Date d'expiration incorrecte",
      inputExpiration: "Merci de saisir la date d'expiration du document",
      duplicatedRequest: 'Demande dupliquée !',
      alreadyHaveRequest: 'Il existe déjà une demande pour ce client.',
      currentRequestStatus: 'Statut actuel de la demande : ',
      requestNoExist: "La demande n'existe pas",
      noRequests: "Il n'y a pas de demandes actives avec le code requis",
      needMoreData: "Nous avons besoin de plus de données pour valider l'accès aux administrations publiques",
      needDNI: 'Le DNI ou NIE est obligatoire',
      needExpirationDate: "La date d'expiration est obligatoire",
      needBirthDate: 'La date de naissance est obligatoire',
      needSupportNumber: 'Le numéro de support est obligatoire',
      needPhone: 'Le numéro de téléphone est obligatoire',
      phoneDigitsRequired: 'Le numéro de téléphone doit contenir 9 chiffres',
      invalidDateFormat: 'Le format doit être JJ/MM/AAAA',
      invalidDate: 'Date invalide',
      underAge: 'Vous devez avoir plus de 18 ans',
      requiredEmail: "L'e-mail est obligatoire",
      invalidEmail: "L'e-mail n'est pas valide",
      needDate: 'La date est obligatoire',
      undefinedError: 'Erreur indéfinie',
      requiredName: 'Le nom est obligatoire',
      requiredFirstSurname: 'Le premier nom est obligatoire',
      requiredSecondSurname: 'Le deuxième nom est obligatoire',
      requiredCompanyName: 'La raison sociale est obligatoire',
      requiredCIF: 'Le CIF est obligatoire',
      selectPersonType: 'Tu dois sélectionner un type de personne',
      readAndAcceptBothTerms: 'Vous devez lire et accepter les deux conditions générales pour continuer',
      acceptPowerTerms: 'Vous devez accepter les conditions du pouvoir numérique',
    },
    abandoned: {
      afterWaitingAcceptanceFileSigned: 'Abandonné pendant la signature du fichier d\'acceptation',
      afterWaitingOtpSS: "Abandonné après avoir attendu l'OTP de la Sécurité sociale",
      afterInvalidOtpSS: "Abandonné après un OTP invalide à la Sécurité sociale",
      afterInvalidOtpAEAT: "Abandonné après un OTP invalide à l'AEAT",
      afterWaitingOtpAEAT: "Abandonné après avoir attendu l'OTP de l'AEAT"
    },
    certificate: {
      mobileOnlyTitle: 'Usage exclusif sur ordinateur ou laptop',
      mobileOnlyLine1: 'Pour garantir la bonne finalisation de ce processus, l\'accès est uniquement autorisé depuis',
      mobileOnlyDevices: 'ordinateurs de bureau ou laptops.',
      mobileOnlyLine2: 'Actuellement, le service n\'est pas compatible avec les appareils mobiles ou les tablettes. Nous vous recommandons de recommencer le processus depuis un ordinateur de bureau ou un laptop.',
      responsibleName: 'Nom de la personne responsable',
      firstSurname: 'Prénom de la personne responsable',
      secondSurname: 'Deuxième prénom de la personne responsable',
      idDocumentNumber: "Numéro de document d'identification",
      companyName: 'Raison sociale',
      dniPlaceholder: 'Ex: 12345678R',
      companyPlaceholder: 'Ex: Mon Entreprise',
      cifPlaceholder: 'Ex: B12345678',
      idFrontUpload: "Recto du document d'identification (Max 2MB)",
      idBackUpload: "Verso du document d'identification (Max 2MB)",
      acceptedDocumentsTitle: "Documents d’identification acceptés",
      acceptedDocumentsDni: "(recto et verso)",
      acceptedDocumentsTie: "(recto et verso). Document NIE avec photographie",
      acceptedDocumentsPassport: "Passeport + Certificat d’attribution du NIE / Carte verte",
      acceptedDocumentsBothRequired: "(les deux sont obligatoires)",
      acceptedDocumentsFormats: 'PDF, JPG, PNG',
      acceptedDocumentsFormatsLabel: "Formats acceptés :",
      acceptedDocumentsMaxSizeLabel: "Taille maximale par fichier :",
      acceptedDocumentsFilesNote: "Vous pouvez envoyer les deux fichiers correspondant au type de document.",
      powerConsentBefore: "J'exprime mon consentement express à l'activation d'un pouvoir numérique selon les conditions qui peuvent être consultées ",
      powerConsentHere: 'ici',
      powerTitle: 'Activer un pouvoir numérique',
      powerDescription: "Nous allons émettre un pouvoir numérique en faveur de EJEMPLO pour obtenir la documentation nécessaire aux demandes de financement. Pour mettre à jour vos informations, nous vous redemanderons toujours votre consentement.",
      powerAcceptSign: "J'accepte et signe numériquement le document",
      powerTcTitle: 'OCTROYER UN POUVOIR NUMÉRIQUE POUR OBTENIR LA DOCUMENTATION AUTOMATIQUEMENT',
      requestAgainIn: 'Demandez-le à nouveau dans',
      seconds: 'secondes',
      status: 'Statut',
      createNewRequest: 'Créer une nouvelle demande',
      noAutofirmaHint: 'Si vous n\'avez pas <strong>Autofirma</strong> installé, accédez au lien suivant pour <a href="https://firmaelectronica.gob.es/Home/Descargas.html" class="text-blue-500 font-bold underline" target="_blank">Installer Autofirma</a>',
      password: {
        label: 'Mot de passe',
        confirmLabel: 'Répéter le mot de passe',
        required: 'Le mot de passe est obligatoire',
        minLength: 'Le mot de passe doit contenir au moins 8 caractères',
        confirmRequired: 'Vous devez répéter le mot de passe',
        mismatch: 'Les mots de passe doivent correspondre',
        save: 'Enregistrer',
      },
      autofirma: {
        signedFileLoaded: 'Fichier signé téléchargé',
        signCertificate: 'Signer le certificat',
        waitingAutofirma: 'En attente d\'Autofirma...',
        noDocument: 'Aucun document à envoyer.',
        prepareError: 'Impossible de préparer le document : ',
        notFoundTitle: 'Autofirma non trouvé',
        notFoundMessage: 'Nous n\'avons pas détecté Autofirma installé sur votre appareil. Veuillez utiliser le lien suivant pour le télécharger et réessayer.',
        timeoutMessage: 'Aucune réponse reçue d\'Autofirma. Vérifiez que l\'application est installée et que le navigateur peut l\'ouvrir, puis réessayez. Si vous ne l\'avez pas encore, vous pouvez le télécharger depuis le lien suivant.',
        downloadAutofirma: 'Télécharger Autofirma',
        cancel: 'Annuler',
        unknownError: 'Erreur inconnue',
        errorOccurred: 'Une erreur s\'est produite : ',
      },
      errors: {
        readServiceTerms: 'Vous devez lire les conditions générales du service',
        readCertTerms: 'Vous devez lire les conditions générales pour l\'émission du certificat',
        acceptServiceTerms: 'Vous devez accepter les conditions générales du service',
        acceptSecurityPolicy: 'Vous devez accepter la politique de sécurité',
        acceptCertTerms: 'Vous devez accepter les conditions générales pour l\'émission du certificat',
        acceptLegalCheck: 'Vous devez accepter la case légale',
        consentPowerActivation: 'Vous devez consentir à l\'activation d\'un pouvoir numérique enregistré au REA',
      },
      loadings: {
        gettingRequestInfo: 'Récupération des informations de la demande',
        uploadingDocs: 'Téléchargement de la documentation...',
        sendingInfo: 'Envoi des informations...',
        startingEmission: 'Démarrage du processus d\'émission du certificat...',
        validatingInfo: 'Validation des informations, merci de patienter...',
        sendingOtp: 'Envoi du code OTP...',
        processingRequest: 'Nous traitons votre demande. Merci de patienter un instant',
      },
      requestRetry: {
        title: 'Erreur de demande',
        description: 'Cette demande est suspendue et a été remplacée par une plus récente. Si vous le souhaitez, vous pouvez continuer le flux avec cette demande en cliquant sur le bouton ci-dessous',
        continueFlow: 'Continuer le flux',
      },
      requisites: {
        haveFde: "J'ai FDE installé, continuer",
        noFde: "Je n'ai pas FDE installé, installer",
        downloadStore: 'Télécharger depuis Microsoft Store',
        fdeOpened: "FDE est ouvert, continuer",
      },
    },
    loadings: {
      gettingData: 'Récupération des données de la demande...',
      resendingOtp: "Renvoi de l'OTP...",
      sendingData: 'Envoi des données...',
      validatingData: 'Validation des nouvelles données, merci de patienter...',
      validatingAndLoginSS: 'Validation des données et connexion à la Sécurité sociale, merci de patienter...',
      validatingAndLoginAEAT: "Validation des données et connexion à l'AEAT, merci de patienter...",
      resendingRequest: "Nouvelle tentative d'envoi de la demande...",
      smsToPin: 'Un numéro de téléphone incorrect a été détecté ; nous allons essayer le flux Clave PIN',
      sendingNewPhone: 'Envoi du nouveau numéro de téléphone, merci de patienter',
      validatingRequest: 'Validation de la demande, merci de patienter...',
      creatingRequest: 'Création de la demande, merci de patienter',
      cancelingRequest: 'Annulation de la demande...',
      checkingSms: 'Vérification du service SMS...',
      loadingDocs: 'Chargement des documents',
      autoUploadTitle: 'Téléchargement automatique des documents',
    },
    actions: {
      continue: 'Continuer',
      cancel: 'Annuler le processus',
      back: 'Retour',
      send: 'Envoyer',
      retry: 'Réessayer',
      resend: 'Renvoyer',
      next: 'Suivant',
      clickToFinish: 'Clique ici pour terminer',
      newRequest: 'Nouvelle demande',
      gotoCurrentRequest: 'Aller à la demande actuelle',
      uploadFiles: 'Télécharger les fichiers',
    },
    otp: {
      requestingOtp: 'Nous demandons le code. Merci de patienter un instant.',
      otpSentToNumber: 'Le code a été envoyé au téléphone se terminant par',
      requestingCode: 'Nous demandons le code. Merci de patienter un instant.',
      noReceivedCode: "Tu n'as pas reçu le code sur ton téléphone ?",
      noReceivedCode2: "Tu n'as pas reçu le code sur le téléphone se terminant par",
      otpCode: 'Code OTP (reçu par SMS)'
    },
    flowCommon: {
      certTermsBefore: "J'ai lu et j'accepte les",
      certTermsLink: 'termes et conditions',
      certTermsAfter: "pour l'émission du certificat",
      loadingData: 'Chargement des données..',
      sendingPassword: 'Envoi du mot de passe..',
      personType: 'Type de personne',
      natural: 'Physique',
      legal: 'Morale',
      name: 'Nom',
      firstSurname: 'Prénom',
      secondSurname: 'Deuxième prénom',
      emailPlaceholder: 'Ex: mi_email@dominio.com',
      phonePlaceholder: 'Ex: 123123123',
      dniPlaceholderShort: 'Ex: 2222221R',
      cifPlaceholderShort: 'Ex: 123123123',
    },
    videoid: {
      waitingVideoId: 'En attente de validation par Video ID',
      redirectingVintegris: 'Redirection vers Vintegris, merci de patienter...',
      sendingPassword: 'Envoi du mot de passe...',
      sendingOtpShort: 'Envoi de l\'OTP...',
      invalidOtpRetry: 'Le code saisi est incorrect. Merci de réessayer',
    },
  },
  it: {
      clavePinQr: {
        title: "Identificati con Cl@ve",
        scanInstructions: "Scansiona questo codice QR con l'app Cl@ve per autorizzare l'accesso.",
        mobileInstructions: "Apri l'app Cl@ve per autorizzare l'accesso.",
        openApp: "Apri l'app Cl@ve",
        fallbackSms: "Non ho l'app Cl@ve. Continua via SMS",
        connecting: "Connessione a Cl@ve…",
        gettingQr: "Recupero del QR",
        timeoutTitle: "Il tempo di attesa è scaduto",
        timeoutText: "Nessuna autorizzazione rilevata nell'app Cl@ve.",
        retry: "Riprova",
        confirmed: "Autorizzazione confermata. Continuazione…",
        dataTitle: "Abbiamo bisogno di alcuni dati",
        dataText: "Inserisci il tuo documento per continuare via SMS.",
        imagesTitle: 'Codici QR Cl@ve', verificationCode: 'Codice di verifica', imageLoading: 'Caricamento codice QR', imageError: 'Impossibile caricare questo codice QR.',
        variants: { oficial: 'Ufficiale', nobrand: 'Senza marchio', deeplink: 'Collegamento diretto' }, imageAlts: { oficial: 'Codice QR Cl@ve ufficiale', nobrand: 'Codice QR Cl@ve senza marchio', deeplink: 'Codice QR collegamento diretto Cl@ve' },
      },
    nie: 'NIE',
    dni: 'DNI',
    nieOrDni: 'DNI o NIE',
    birthday: 'Data di nascita',
    expiration: 'Data di scadenza del DNI',
    support: 'Codice di supporto',
    phone: 'Telefono',
    email: 'Email',
    inputEmail: 'Inserisci la tua email',
    findExpiration: 'Dove la trovo?',
    send: 'Invia',
    unknownState: 'Stato sconosciuto',
    manual: 'Inserisci manualmente',

    naturalPerson: 'Persona fisica',
    legalPerson: 'Persona giuridica',
    cif: 'CIF',

    warnings: {
      error: 'Errore!',
      invalidDni: 'Devi inserire un DNI valido!',
      invalidNie: 'Devi inserire un NIE valido!',
      invalidNieOrDni: 'Devi inserire un DNI o NIE valido!',
      errorSomeData: 'Errore in alcuni dati',
      noPinService: 'Servizio Clave PIN non disponibile',
      noCirbeService: 'Servizio Cirbe non disponibile',
      noCustomization: 'La personalizzazione del widget non è stata configurata per questo utente',
      ocassionalError: 'Stiamo rilevando errori occasionali, se non riesci a completare la tua richiesta, riprova più tardi',
      wrongDni: 'Numero di documento errato',
      wrongDniDesc: 'Il numero di documento inserito è errato, inseriscine un altro per favore',
      wrongDate: 'Data errata',
      wrongDateDesc: 'La data è errata. Per favore, controllala',
      wrongSupport: 'Codice di supporto non valido!',
      inputSupport: 'Per favore, inserisci il codice di supporto',
      unknownError: 'Errore sconosciuto: ',
      noSms: 'Servizio SMS non disponibile',
      noSmsDesc: 'L\'utente non ha il servizio SMS, proveremo ad accedere tramite il flusso Clave PIN, per favore compila i campi necessari',
      noOtp: 'Non hai ancora ricevuto l\'OTP. Riprova quando lo ricevi',
      wrongOtp: 'Codice non valido. Per favore, inserisci il codice ricevuto via SMS',
      haveToReadTerms: 'Devi leggere i termini e le condizioni per poter continuare',
      haveToAcceptPolicy: 'Devi accettare la politica sulla privacy per poter continuare',
      haveToAcceptAssignment: 'Devi accettare la cessione dei dati per poter continuare',
      phoneError: 'Errore con il telefono',
      dontHavePhone: 'Non ho un altro telefono',
      badPhoneSS: 'Il telefono inserito non corrisponde a quello registrato presso la Sicurezza Sociale, inseriscine un altro per favore',
      wrongBirthday: 'Data di nascita errata',
      inputBirthDay: 'Per favore, inserisci la data di nascita',
      wrongExpiration: 'Data di scadenza errata',
      inputExpiration: 'Per favore, inserisci la data di scadenza del documento',
      duplicatedRequest: 'Richiesta duplicata!',
      alreadyHaveRequest: 'Esiste già una richiesta per questo cliente.',
      currentRequestStatus: 'Stato della richiesta attuale: ',
      requestNoExist: 'La richiesta non esiste',
      noRequests: 'Non esistono richieste attive con il codice richiesto',
      needMoreData: 'Abbiamo bisogno di più dati per convalidare l\'accesso alle amministrazioni pubbliche',
      needDNI: 'Il DNI o NIE è obbligatorio',
      needExpirationDate: 'La data di scadenza è obbligatoria',
      needBirthDate: 'La data di nascita è obbligatoria',
      needSupportNumber: 'Il numero di supporto è obbligatorio',
      needPhone: 'Il numero di telefono è obbligatorio',
      phoneDigitsRequired: 'Il numero di telefono deve avere 9 cifre',
      invalidDateFormat: 'Il formato deve essere GG/MM/AAAA',
      invalidDate: 'Data non valida',
      underAge: 'Devi avere almeno 18 anni',
      requiredEmail: "L'email è obbligatoria",
      invalidEmail: "L'email non è valida",
      needDate: 'La data è obbligatoria',
      undefinedError: 'Errore indefinito',
      requiredName: 'Il nome è obbligatorio',
      requiredFirstSurname: 'Il cognome è obbligatorio',
      requiredSecondSurname: 'Il secondo cognome è obbligatorio',
      requiredCompanyName: 'La ragione sociale è obbligatoria',
      requiredCIF: 'Il CIF è obbligatorio',
      selectPersonType: 'Devi selezionare un tipo di persona',
      readAndAcceptBothTerms: 'Devi leggere e accettare entrambi i termini e le condizioni per continuare',
      acceptPowerTerms: 'Devi accettare i termini del potere digitale',
    },
    abandoned: {
      afterWaitingAcceptanceFileSigned: 'Abbandonato durante la firma del file di accettazione',
      afterWaitingOtpSS: 'Abbandonato dopo aver atteso l\'OTP della Sicurezza Sociale',
      afterInvalidOtpSS: 'Abbandonato dopo OTP non valido nella Sicurezza Sociale',
      afterInvalidOtpAEAT: 'Abbandonato dopo OTP non valido nell\'AEAT',
      afterWaitingOtpAEAT: 'Abbandonato dopo aver atteso l\'OTP dell\'AEAT',
    },
    certificate: {
      mobileOnlyTitle: 'Uso esclusivo su computer o laptop',
      mobileOnlyLine1: 'Per garantire la corretta completione di questo processo, l\'accesso è abilitato solo da',
      mobileOnlyDevices: 'computer desktop o laptop.',
      mobileOnlyLine2: 'Attualmente, il servizio non è compatibile con dispositivi mobili o tablet. Ti consigliamo di riprocessare il processo da un computer desktop o laptop.',
      responsibleName: 'Nome della persona responsabile',
      firstSurname: 'Cognome della persona responsabile',
      secondSurname: 'Secondo cognome della persona responsabile',
      idDocumentNumber: 'Numero del documento di identificazione',
      companyName: 'Ragione sociale',
      dniPlaceholder: 'Es: 12345678R',
      companyPlaceholder: 'Es: La Mia Azienda',
      cifPlaceholder: 'Es: B12345678',
      idFrontUpload: 'Fronte del documento di identificazione (Max 2MB)',
      idBackUpload: 'Retro del documento di identificazione (Max 2MB)',
      acceptedDocumentsTitle: "Documenti di identificazione accettati",
      acceptedDocumentsDni: "(fronte e retro)",
      acceptedDocumentsTie: "(fronte e retro). Documento NIE con fotografia",
      acceptedDocumentsPassport: "Passaporto + Certificato di assegnazione del NIE / Carta verde",
      acceptedDocumentsBothRequired: "(entrambi sono obbligatori)",
      acceptedDocumentsFormats: 'PDF, JPG, PNG',
      acceptedDocumentsFormatsLabel: "Formati accettati:",
      acceptedDocumentsMaxSizeLabel: "Dimensione massima per file:",
      acceptedDocumentsFilesNote: "Puoi caricare i due file corrispondenti al tipo di documento.",
      powerConsentBefore: 'Consento espressamente l\'attivazione di un potere digitale secondo le condizioni che possono essere visionate ',
      powerConsentHere: 'qui',
      powerTitle: 'Attiva un potere digitale',
      powerDescription: 'Emetteremo un potere digitale a favore di EJEMPLO per ottenere la documentazione necessaria nelle richieste di finanziamento. Per aggiornare le tue informazioni, ti chiederemo sempre nuovamente il consenso.',
      powerAcceptSign: 'Accetto e firmo digitalmente il documento',
      powerTcTitle: 'CONCEDERE UN POTERE DIGITALE PER OTTENERE LA DOCUMENTAZIONE AUTOMATICAMENTE',
      requestAgainIn: 'Richiedilo di nuovo tra',
      seconds: 'secondi',
      status: 'Stato',
      createNewRequest: 'Crea nuova richiesta',
      noAutofirmaHint: 'Se non hai <strong>Autofirma</strong> installato, accedi al seguente link per <a href="https://firmaelectronica.gob.es/Home/Descargas.html" class="text-blue-500 font-bold underline" target="_blank">Installare Autofirma</a>',
      password: {
        label: 'Password',
        confirmLabel: 'Ripeti password',
        required: 'La password è obbligatoria',
        minLength: 'La password deve contenere almeno 8 caratteri',
        confirmRequired: 'È necessario ripetere la password',
        mismatch: 'Le password devono coincidere',
        save: 'Salva',
      },
      autofirma: {
        signedFileLoaded: 'File firmato caricato',
        signCertificate: 'Firma certificato',
        waitingAutofirma: 'In attesa di Autofirma...',
        noDocument: 'Non c\'è documento da inviare.',
        prepareError: 'Impossibile preparare il documento: ',
        notFoundTitle: 'Autofirma non trovato',
        notFoundMessage: 'Non abbiamo rilevato Autofirma installato sul tuo dispositivo. Utilizza il seguente link per scaricarlo e riprova.',
        timeoutMessage: 'Non è stata ricevuta risposta da Autofirma. Verifica che l\'applicazione sia installata e che il browser possa aprirla, poi riprova. Se non ce l\'hai ancora, puoi scaricarla dal seguente link.',
        downloadAutofirma: 'Scarica Autofirma',
        cancel: 'Annulla',
        unknownError: 'Errore sconosciuto',
        errorOccurred: 'Si è verificato un errore: ',
      },
      errors: {
        readServiceTerms: 'Devi leggere i termini e le condizioni del servizio',
        readCertTerms: 'Devi leggere i termini e le condizioni per l\'emissione del certificato',
        acceptServiceTerms: 'Devi accettare i termini e le condizioni del servizio',
        acceptSecurityPolicy: 'Devi accettare la politica di sicurezza',
        acceptCertTerms: 'Devi accettare i termini e le condizioni per l\'emissione del certificato',
        acceptLegalCheck: 'Devi accettare la casella legale',
        consentPowerActivation: 'Devi acconsentire all\'attivazione di un potere digitale registrato nel REA',
      },
      loadings: {
        gettingRequestInfo: 'Recupero informazioni sulla richiesta',
        uploadingDocs: 'Caricamento documentazione...',
        sendingInfo: 'Invio informazioni...',
        startingEmission: 'Avvio del processo di emissione del certificato...',
        validatingInfo: 'Validazione informazioni, attendere per favore...',
        sendingOtp: 'Invio codice OTP...',
        processingRequest: 'Stiamo processando la tua richiesta. Attendere un momento per favore',
      },
      requestRetry: {
        title: 'Errore con la richiesta',
        description: 'Questa richiesta è sospesa ed è stata sostituita da una più recente. Se lo desideri, puoi continuare il flusso con quella richiesta cliccando il pulsante qui sotto',
        continueFlow: 'Continua flusso',
      },
      requisites: {
        haveFde: 'Ho FDE installato, continuare',
        noFde: 'Non ho FDE installato, installare',
        downloadStore: 'Scarica da Microsoft Store',
        fdeOpened: 'FDE è aperto, continuare',
      },
    },
    loadings: {
      gettingData: 'Recupero dei dati della richiesta...',
      resendingOtp: 'Invio nuovamente l\'OTP...',
      sendingData: 'Invio dei dati...',
      validatingData: 'Validazione dei nuovi dati, attendere per favore...',
      validatingAndLoginSS: 'Validazione dei dati e accesso alla Sicurezza Sociale, attendere per favore...',
      validatingAndLoginAEAT: 'Validazione dei dati e accesso all\'AEAT, attendere per favore...',
      resendingRequest: 'Nuovo tentativo di invio della richiesta...',
      smsToPin: 'È stato rilevato un numero di telefono errato, proveremo tramite il flusso Clave PIN',
      sendingNewPhone: 'Invio del nuovo telefono, attendere per favore',
      validatingRequest: 'Validazione della richiesta, attendere per favore...',
      creatingRequest: 'Creazione della richiesta, attendere per favore',
      cancelingRequest: 'Annullamento della richiesta...',
      checkingSms: 'Verifica del servizio SMS...',
      loadingDocs: 'Caricamento documenti',
      autoUploadTitle: 'Caricamento automatico dei documenti',
    },
    actions: {
      continue: 'Continua',
      cancel: 'Annulla processo',
      back: 'Indietro',
      send: 'Invia',
      retry: 'Riprova',
      resend: 'Reinvia',
      next: 'Avanti',
      clickToFinish: 'Clicca qui per terminare',
      newRequest: 'Nuova richiesta',
      gotoCurrentRequest: 'Vai alla richiesta attuale',
      uploadFiles: 'Carica file',
    },
    otp: {
      requestingOtp: 'Stiamo richiedendo il codice. Attendere un momento, per favore.',
      otpSentToNumber: 'Il codice è stato inviato al telefono che termina con',
      requestingCode: 'Stiamo richiedendo il codice. Attendere un momento, per favore.',
      noReceivedCode: 'Non hai ricevuto il codice sul tuo telefono?',
      noReceivedCode2: 'Non hai ricevuto il codice sul telefono che termina con',
      otpCode: 'Codice OTP (ricevuto via SMS)',
    },
    flowCommon: {
      certTermsBefore: 'Ho letto e accetto i',
      certTermsLink: 'termini e condizioni',
      certTermsAfter: "per l'emissione del certificato",
      loadingData: 'Caricamento dati..',
      sendingPassword: 'Invio password..',
      personType: 'Tipo di persona',
      natural: 'Fisica',
      legal: 'Giuridica',
      name: 'Nome',
      firstSurname: 'Cognome',
      secondSurname: 'Secondo cognome',
      emailPlaceholder: 'Es: mi_email@dominio.com',
      phonePlaceholder: 'Es: 123123123',
      dniPlaceholderShort: 'Es: 2222221R',
      cifPlaceholderShort: 'Es: 123123123',
    },
    videoid: {
      waitingVideoId: 'In attesa di validazione Video ID',
      redirectingVintegris: 'Reindirizzamento a Vintegris, attendere per favore...',
      sendingPassword: 'Invio password...',
      sendingOtpShort: 'Invio OTP...',
      invalidOtpRetry: 'Il codice inserito non è corretto. Per favore, riprova',
    },
  },
  pt: {
      clavePinQr: {
        title: "Identifique-se com o Cl@ve",
        scanInstructions: "Leia este código QR com a app Cl@ve para autorizar o acesso.",
        mobileInstructions: "Abra a app Cl@ve para autorizar o acesso.",
        openApp: "Abrir a app Cl@ve",
        fallbackSms: "Não tenho a app Cl@ve. Continuar por SMS",
        connecting: "A ligar ao Cl@ve…",
        gettingQr: "A obter o QR",
        timeoutTitle: "O tempo de espera terminou",
        timeoutText: "Não foi detetada autorização na app Cl@ve.",
        retry: "Tentar novamente",
        confirmed: "Autorização confirmada. A continuar…",
        dataTitle: "Precisamos de alguns dados",
        dataText: "Introduza o seu documento para continuar por SMS.",
        imagesTitle: 'Códigos QR Cl@ve', verificationCode: 'Código de verificação', imageLoading: 'A carregar código QR', imageError: 'Não foi possível carregar este código QR.',
        variants: { oficial: 'Oficial', nobrand: 'Sem marca', deeplink: 'Ligação direta' }, imageAlts: { oficial: 'Código QR oficial Cl@ve', nobrand: 'Código QR Cl@ve sem marca', deeplink: 'Código QR de ligação direta Cl@ve' },
      },
    nie: 'NIE',
    dni: 'DNI',
    nieOrDni: 'DNI ou NIE',
    birthday: 'Data de nascimento',
    expiration: 'Data de validade do DNI',
    support: 'Código de suporte',
    phone: 'Telefone',
    email: 'E-mail',
    inputEmail: 'Digite seu e-mail',
    findExpiration: 'Onde encontro?',
    send: 'Enviar',
    unknownState: 'Estado desconhecido',
    manual: 'Inserir manualmente',

    naturalPerson: 'Pessoa física',
    legalPerson: 'Pessoa jurídica',
    cif: 'CIF',

    warnings: {
      error: 'Erro!',
      invalidDni: 'Você deve inserir um DNI válido!',
      invalidNie: 'Você deve inserir um NIE válido!',
      invalidNieOrDni: 'Você deve inserir um DNI ou NIE válido!',
      errorSomeData: 'Erro em alguns dados',
      noPinService: 'Sem serviço Clave PIN',
      noCirbeService: 'Sem serviço Cirbe',
      noCustomization: 'A personalização do widget não foi configurada para este usuário',
      ocassionalError: 'Estamos detectando erros ocasionais; se não conseguir concluir sua solicitação, tente novamente mais tarde',
      wrongDni: 'Número de documento incorreto',
      wrongDniDesc: 'O número de documento informado está incorreto, insira outro por favor',
      wrongDate: 'Data incorreta',
      wrongDateDesc: 'A data está incorreta. Verifique, por favor',
      wrongSupport: 'Código de suporte inválido!',
      inputSupport: 'Por favor, insira o código de suporte',
      unknownError: 'Erro desconhecido: ',
      noSms: 'Sem serviço SMS',
      noSmsDesc: 'O usuário não possui serviço de SMS; vamos tentar entrar pelo fluxo Clave PIN, por favor preencha os campos necessários',
      noOtp: 'Você ainda não recebeu o OTP. Tente novamente quando recebê-lo',
      wrongOtp: 'Código inválido. Por favor, insira o código recebido por SMS',
      haveToReadTerms: 'Você deve ler os termos e condições para continuar',
      haveToAcceptPolicy: 'Você deve aceitar a política de privacidade para continuar',
      haveToAcceptAssignment: 'Você deve aceitar a cessão de dados para continuar',
      phoneError: 'Erro com o telefone',
      dontHavePhone: 'Não tenho outro telefone',
      badPhoneSS: 'O telefone informado não coincide com o registrado na Seguridade Social, por favor insira outro',
      wrongBirthday: 'Data de nascimento incorreta',
      inputBirthDay: 'Por favor, insira a data de nascimento',
      wrongExpiration: 'Data de validade incorreta',
      inputExpiration: 'Por favor, insira a data de validade do documento',
      duplicatedRequest: 'Solicitação duplicada!',
      alreadyHaveRequest: 'Já existe uma solicitação para este cliente.',
      currentRequestStatus: 'Status da solicitação atual: ',
      requestNoExist: 'A solicitação não existe',
      noRequests: 'Não existem solicitações ativas com o código informado',
      needMoreData: 'Precisamos de mais dados para validar o acesso às administrações públicas',
      needDNI: 'O DNI ou NIE é obrigatório',
      needExpirationDate: 'A data de validade é obrigatória',
      needBirthDate: 'A data de nascimento é obrigatória',
      needSupportNumber: 'O número de suporte é obrigatório',
      needPhone: 'O número de telefone é obrigatório',
      phoneDigitsRequired: 'O número de telefone deve ter 9 dígitos',
      invalidDateFormat: 'O formato deve ser DD/MM/AAAA',
      invalidDate: 'Data inválida',
      underAge: 'Deve ter mais de 18 anos',
      requiredEmail: 'O e-mail é obrigatório',
      invalidEmail: 'O e-mail não é válido',
      needDate: 'A data é obrigatória',
      undefinedError: 'Erro indefinido',
      requiredName: 'O nome é obrigatório',
      requiredFirstSurname: 'O primeiro apelido é obrigatório',
      requiredSecondSurname: 'O segundo apelido é obrigatório',
      requiredCompanyName: 'A razão social é obrigatória',
      requiredCIF: 'O CIF é obrigatório',
      selectPersonType: 'Deve selecionar um tipo de pessoa',
      readAndAcceptBothTerms: 'Deve ler e aceitar ambos os termos e condições para continuar',
      acceptPowerTerms: 'Deve aceitar os termos do poder digital',
    },
    abandoned: {
      afterWaitingAcceptanceFileSigned: 'Abandonado durante a assinatura do ficheiro de aceitação',
      afterWaitingOtpSS: 'Abandonado após aguardar o OTP da Seguridade Social',
      afterInvalidOtpSS: 'Abandonado após OTP inválido na Seguridade Social',
      afterInvalidOtpAEAT: 'Abandonado após OTP inválido na AEAT',
      afterWaitingOtpAEAT: 'Abandonado após aguardar o OTP da AEAT',
    },
    loadings: {
      gettingData: 'Obtendo dados da solicitação...',
      resendingOtp: 'Reenviando OTP...',
      sendingData: 'Enviando dados...',
      validatingData: 'Validando novos dados, aguarde por favor...',
      validatingAndLoginSS: 'Validando dados e acessando a Seguridade Social, aguarde por favor...',
      validatingAndLoginAEAT: 'Validando dados e acessando a AEAT, aguarde por favor...',
      resendingRequest: 'Tentando reenviar a solicitação...',
      smsToPin: 'Detectamos um número de telefone incorreto, vamos tentar pelo fluxo Clave PIN',
      sendingNewPhone: 'Enviando novo telefone, aguarde por favor',
      validatingRequest: 'Validando solicitação, aguarde por favor...',
      creatingRequest: 'Criando solicitação, aguarde por favor',
      cancelingRequest: 'Cancelando solicitação...',
      checkingSms: 'Verificando serviço SMS...',
      loadingDocs: 'Carregando documentos',
      autoUploadTitle: 'Upload automático dos documentos',
    },
    actions: {
      continue: 'Continuar',
      cancel: 'Cancelar processo',
      back: 'Voltar',
      send: 'Enviar',
      retry: 'Tentar novamente',
      resend: 'Reenviar',
      next: 'Seguinte',
      clickToFinish: 'Clique aqui para finalizar',
      newRequest: 'Nova solicitação',
      gotoCurrentRequest: 'Ir para a solicitação atual',
      uploadFiles: 'Carregar arquivos',
    },
    otp: {
      requestingOtp: 'Estamos solicitando o código. Por favor, aguarde um momento.',
      otpSentToNumber: 'O código foi enviado para o telefone terminado em',
      requestingCode: 'Estamos solicitando o código. Por favor, aguarde um momento.',
      noReceivedCode: 'Não recebeu o código no seu telefone?',
      noReceivedCode2: 'Não recebeu o código no telefone terminado em',
      otpCode: 'Código OTP (recebido por SMS)',
    },
    certificate: {
      mobileOnlyTitle: 'Uso exclusivo em computadores ou portáteis',
      mobileOnlyLine1: 'Para garantir a conclusão correta deste processo, o acesso está habilitado apenas em',
      mobileOnlyDevices: 'computadores de mesa ou portáteis.',
      mobileOnlyLine2: 'Atualmente, o serviço não é compatível com dispositivos móveis ou tablets. Recomendamos que reinicie o processo a partir de um computador ou portátil.',
      responsibleName: 'Nome da pessoa responsável',
      firstSurname: 'Primeiro apelido da pessoa responsável',
      secondSurname: 'Segundo apelido da pessoa responsável',
      idDocumentNumber: 'Número do documento de identificação',
      companyName: 'Razão social',
      dniPlaceholder: 'Ex.: 12345678R',
      companyPlaceholder: 'Ex.: A minha empresa',
      cifPlaceholder: 'Ex.: B12345678',
      idFrontUpload: 'Frente do documento de identificação (máx. 2 MB)',
      idBackUpload: 'Verso do documento de identificação (máx. 2 MB)',
      acceptedDocumentsTitle: "Documentos de identificação aceites",
      acceptedDocumentsDni: "(frente e verso)",
      acceptedDocumentsTie: "(frente e verso). Documento NIE com fotografia",
      acceptedDocumentsPassport: "Passaporte + Certificado de atribuição do NIE / Cartão Verde",
      acceptedDocumentsBothRequired: "(ambos são obrigatórios)",
      acceptedDocumentsFormats: 'PDF, JPG, PNG',
      acceptedDocumentsFormatsLabel: "Formatos aceites:",
      acceptedDocumentsMaxSizeLabel: "Tamanho máximo por ficheiro:",
      acceptedDocumentsFilesNote: "Podes carregar os dois ficheiros correspondentes ao tipo de documento.",
      powerConsentBefore: 'Consinto expressamente a ativação de um poder digital de acordo com as condições que podem ser consultadas ',
      powerConsentHere: 'aqui',
      powerTitle: 'Ativar um poder digital',
      powerDescription: 'Vamos emitir um poder digital em favor de EJEMPLO para obter a documentação necessária em solicitações de financiamento. Para atualizar suas informações, sempre pediremos seu consentimento novamente.',
      powerAcceptSign: 'Aceito e assino digitalmente o documento',
      powerTcTitle: 'CONCEDER UM PODER DIGITAL PARA OBTER A DOCUMENTAÇÃO AUTOMATICAMENTE',
      requestAgainIn: 'Solicite novamente em',
      seconds: 'segundos',
      status: 'Estado',
      createNewRequest: 'Criar nova solicitação',
      noAutofirmaHint: 'Se não tem o <strong>Autofirma</strong> instalado, aceda à seguinte ligação para <a href="https://firmaelectronica.gob.es/Home/Descargas.html" class="text-blue-500 font-bold underline" target="_blank">Instalar Autofirma</a>',
      password: {
        label: 'Palavra-passe',
        confirmLabel: 'Repetir palavra-passe',
        required: 'A palavra-passe é obrigatória',
        minLength: 'A palavra-passe deve ter pelo menos 8 caracteres',
        confirmRequired: 'É necessário repetir a palavra-passe',
        mismatch: 'As palavras-passe devem coincidir',
        save: 'Guardar',
      },
      autofirma: {
        signedFileLoaded: 'Ficheiro assinado carregado',
        signCertificate: 'Assinar certificado',
        waitingAutofirma: 'A aguardar Autofirma...',
        noDocument: 'Não há documento para enviar.',
        prepareError: 'Não foi possível preparar o documento: ',
        notFoundTitle: 'Autofirma não encontrado',
        notFoundMessage: 'Não detetámos o Autofirma instalado no seu equipamento. Utilize o seguinte link para descarregá-lo e tente novamente.',
        timeoutMessage: 'Não foi recebida resposta do Autofirma. Verifique se a aplicação está instalada e se o navegador a pode abrir, e tente novamente. Se ainda não a tiver, pode descarregá-la no link seguinte.',
        downloadAutofirma: 'Descarregar Autofirma',
        cancel: 'Cancelar',
        unknownError: 'Erro desconhecido',
        errorOccurred: 'Ocorreu um erro: ',
      },
      errors: {
        readServiceTerms: 'Deve ler os termos e condições do serviço',
        readCertTerms: 'Deve ler os termos e condições para a emissão do certificado',
        acceptServiceTerms: 'Deve aceitar os termos e condições do serviço',
        acceptSecurityPolicy: 'Deve aceitar a política de segurança',
        acceptCertTerms: 'Deve aceitar os termos e condições para a emissão do certificado',
        acceptLegalCheck: 'Deve aceitar o check legal',
        consentPowerActivation: 'Deve consentir a ativação de um poder digital registado no REA',
      },
      loadings: {
        gettingRequestInfo: 'A obter informação da solicitação',
        uploadingDocs: 'A carregar documentação...',
        sendingInfo: 'A enviar informação...',
        startingEmission: 'A iniciar o processo de emissão do certificado...',
        validatingInfo: 'A validar informação, aguarde por favor...',
        sendingOtp: 'A enviar código OTP...',
        processingRequest: 'Estamos a processar a sua solicitação. Aguarde um momento, por favor',
      },
      requestRetry: {
        title: 'Erro na solicitação',
        description: 'Esta solicitação está suspensa e foi substituída por outra mais recente. Se desejar, pode continuar o fluxo com essa solicitação clicando no botão abaixo',
        continueFlow: 'Continuar fluxo',
      },
      requisites: {
        haveFde: 'Tenho o FDE instalado, continuar',
        noFde: 'Não tenho o FDE instalado, instalar',
        downloadStore: 'Descarregar da Microsoft Store',
        fdeOpened: 'O FDE já abriu, continuar',
      },
    },
    flowCommon: {
      personType: 'Tipo de pessoa',
      natural: 'Natural',
      legal: 'Jurídica',
      name: 'Nome',
      firstSurname: 'Primeiro apelido',
      secondSurname: 'Segundo apelido',
      emailPlaceholder: 'Ex.: o_meu_email@dominio.com',
      phonePlaceholder: 'Ex.: 123123123',
      dniPlaceholderShort: 'Ex.: 2222221R',
      cifPlaceholderShort: 'Ex.: 123123123',
      certTermsBefore: 'Li e aceito os',
      certTermsLink: 'termos e condições',
      certTermsAfter: 'para a emissão do certificado',
      loadingData: 'A carregar dados...',
      sendingPassword: 'A enviar palavra-passe...',
    },
    videoid: {
      waitingVideoId: 'A aguardar validação por Video ID',
      redirectingVintegris: 'A redirecionar para Vintegris, aguarde por favor...',
      sendingPassword: 'A enviar palavra-passe...',
      sendingOtpShort: 'A enviar OTP...',
      invalidOtpRetry: 'O código introduzido não está correto. Por favor, tente novamente',
    },
  },
  de: {
      clavePinQr: {
        title: "Mit Cl@ve identifizieren",
        scanInstructions: "Scannen Sie diesen QR-Code mit der Cl@ve-App, um den Zugriff zu autorisieren.",
        mobileInstructions: "Öffnen Sie die Cl@ve-App, um den Zugriff zu autorisieren.",
        openApp: "Cl@ve-App öffnen",
        fallbackSms: "Ich habe die Cl@ve-App nicht. Per SMS fortfahren",
        connecting: "Verbindung mit Cl@ve…",
        gettingQr: "QR wird abgerufen",
        timeoutTitle: "Die Wartezeit ist abgelaufen",
        timeoutText: "In der Cl@ve-App wurde keine Autorisierung erkannt.",
        retry: "Erneut versuchen",
        confirmed: "Autorisierung bestätigt. Wird fortgesetzt…",
        dataTitle: "Wir benötigen einige Angaben",
        dataText: "Geben Sie Ihr Ausweisdokument ein, um per SMS fortzufahren.",
        imagesTitle: 'Cl@ve-QR-Codes', verificationCode: 'Bestätigungscode', imageLoading: 'QR-Code wird geladen', imageError: 'Dieser QR-Code konnte nicht geladen werden.',
        variants: { oficial: 'Offiziell', nobrand: 'Ohne Marke', deeplink: 'Direktlink' }, imageAlts: { oficial: 'Offizieller Cl@ve-QR-Code', nobrand: 'Cl@ve-QR-Code ohne Marke', deeplink: 'Cl@ve-Direktlink-QR-Code' },
      },
    nie: 'NIE',
    dni: 'DNI',
    nieOrDni: 'DNI oder NIE',
    birthday: 'Geburtsdatum',
    expiration: 'Ablaufdatum des DNI',
    support: 'Support-Code',
    phone: 'Telefon',
    email: 'E-Mail',
    inputEmail: 'Gib deine E-Mail ein',
    findExpiration: 'Wo finde ich ihn?',
    send: 'Senden',
    unknownState: 'Unbekannter Status',
    manual: 'Manuell eingeben',

    naturalPerson: 'Natürliche Person',
    legalPerson: 'Juristische Person',
    cif: 'CIF',

    warnings: {
      error: 'Fehler!',
      invalidDni: 'Du musst eine gültige DNI eingeben!',
      invalidNie: 'Du musst eine gültige NIE eingeben!',
      invalidNieOrDni: 'Du musst eine gültige DNI oder NIE eingeben!',
      errorSomeData: 'Fehler in einigen Angaben',
      noPinService: 'Kein Clave-PIN-Dienst',
      noCirbeService: 'Kein Cirbe-Dienst',
      noCustomization: 'Das Widget wurde für diesen Benutzer nicht konfiguriert',
      ocassionalError: 'Wir stellen gelegentliche Fehler fest. Wenn du deine Anfrage nicht abschließen kannst, versuche es später erneut',
      wrongDni: 'Dokumentennummer falsch',
      wrongDniDesc: 'Die eingegebene Dokumentennummer ist falsch, bitte gib eine andere ein',
      wrongDate: 'Datum falsch',
      wrongDateDesc: 'Das Geburtsdatum ist falsch. Bitte überprüfe es',
      wrongSupport: 'Support-Code ungültig!',
      inputSupport: 'Bitte gib den Support-Code ein',
      unknownError: 'Unbekannter Fehler: ',
      noSms: 'Kein SMS-Dienst',
      noSmsDesc: 'Der Benutzer hat keinen SMS-Dienst. Wir versuchen es über den Clave-PIN-Fluss. Bitte fülle die erforderlichen Felder aus',
      noOtp: 'Du hast den OTP noch nicht erhalten. Versuche es erneut, wenn du ihn erhältst',
      wrongOtp: 'Ungültiger Code. Bitte gib den per SMS erhaltenen Code ein',
      haveToReadTerms: 'Du musst die Allgemeinen Geschäftsbedingungen lesen, um fortzufahren',
      haveToAcceptPolicy: 'Du musst die Datenschutzrichtlinie akzeptieren, um fortzufahren',
      haveToAcceptAssignment: 'Du musst die Datenweitergabe akzeptieren, um fortzufahren',
      phoneError: 'Fehler mit dem Telefon',
      dontHavePhone: 'Ich habe kein anderes Telefon',
      badPhoneSS: 'Die eingegebene Telefonnummer stimmt nicht mit der bei der Sozialversicherung registrierten überein, bitte gib eine andere ein',
      wrongBirthday: 'Geburtsdatum falsch',
      inputBirthDay: 'Bitte gib das Geburtsdatum ein',
      wrongExpiration: 'Ablaufdatum falsch',
      inputExpiration: 'Bitte gib das Ablaufdatum des Dokuments ein',
      duplicatedRequest: 'Doppelte Anfrage!',
      alreadyHaveRequest: 'Es existiert bereits eine Anfrage für diesen Kunden.',
      currentRequestStatus: 'Status der aktuellen Anfrage: ',
      requestNoExist: 'Die Anfrage existiert nicht',
      noRequests: 'Es gibt keine aktiven Anfragen mit dem angegebenen Code',
      needMoreData: 'Wir benötigen weitere Daten, um den Zugang zu öffentlichen Verwaltungen zu prüfen',
      needDNI: 'Der DNI oder NIE ist erforderlich',
      needExpirationDate: 'Das Ablaufdatum ist erforderlich',
      needBirthDate: 'Das Geburtsdatum ist erforderlich',
      needSupportNumber: 'Die Support-Nummer ist erforderlich',
      needPhone: 'Die Telefonnummer ist erforderlich',
      phoneDigitsRequired: 'Die Telefonnummer muss 9 Ziffern haben',
      invalidDateFormat: 'Das Format muss TT/MM/JJJJ sein',
      invalidDate: 'Ungültiges Datum',
      underAge: 'Du musst mindestens 18 Jahre alt sein',
      requiredEmail: 'Die E-Mail-Adresse ist erforderlich',
      invalidEmail: 'Die E-Mail-Adresse ist ungültig',
      needDate: 'Das Datum ist erforderlich',
      undefinedError: 'Unbekannter Fehler',
      requiredName: 'Der Vorname ist erforderlich',
      requiredFirstSurname: 'Der Nachname ist erforderlich',
      requiredSecondSurname: 'Der zweite Nachname ist erforderlich',
      requiredCompanyName: 'Der Firmenname ist erforderlich',
      requiredCIF: 'Die CIF-Nummer ist erforderlich',
      selectPersonType: 'Du musst eine Person auswählen',
      readAndAcceptBothTerms: 'Du musst beide Geschäftsbedingungen lesen und akzeptieren, um fortzufahren',
      acceptPowerTerms: 'Du musst die Bedingungen der digitalen Vollmacht akzeptieren',
    },
    abandoned: {
      afterWaitingAcceptanceFileSigned: 'Abgebrochen während der Signatur der Annahmedatei',
      afterWaitingOtpSS: 'Abgebrochen nach Warten auf OTP der Sozialversicherung',
      afterInvalidOtpSS: 'Abgebrochen nach ungültigem OTP bei der Sozialversicherung',
      afterInvalidOtpAEAT: 'Abgebrochen nach ungültigem OTP bei der AEAT',
      afterWaitingOtpAEAT: 'Abgebrochen nach Warten auf OTP der AEAT',
    },
    certificate: {
      mobileOnlyTitle: 'Nur für Desktop- oder Laptop-Nutzung',
      mobileOnlyLine1: 'Um sicherzustellen, dass dieser Prozess korrekt abgeschlossen wird, ist der Zugriff nur möglich von',
      mobileOnlyDevices: 'Desktop- oder Laptop-Computern.',
      mobileOnlyLine2: 'Dieser Dienst ist derzeit nicht mit mobilen Geräten oder Tablets kompatibel. Bitte starten Sie den Prozess erneut von einem Desktop- oder Laptop-Computer.',
      responsibleName: 'Name der verantwortlichen Person',
      firstSurname: 'Vorname der verantwortlichen Person',
      secondSurname: 'Zweiter Vorname der verantwortlichen Person',
      idDocumentNumber: 'Identifikationsdokument-Nummer',
      companyName: 'Firmenname',
      dniPlaceholder: 'z.B.: 12345678R',
      companyPlaceholder: 'z.B.: Meine Firma',
      cifPlaceholder: 'z.B.: B12345678',
      idFrontUpload: 'Vorderseite des Identifikationsdokuments (Max 2MB)',
      idBackUpload: 'Rückseite des Identifikationsdokuments (Max 2MB)',
      acceptedDocumentsTitle: "Akzeptierte Identifikationsdokumente",
      acceptedDocumentsDni: "(Vorder- und Rückseite)",
      acceptedDocumentsTie: "(Vorder- und Rückseite). NIE-Dokument mit Foto",
      acceptedDocumentsPassport: "Reisepass + Bescheinigung über die Zuweisung der NIE / Grüne Karte",
      acceptedDocumentsBothRequired: "(beide sind erforderlich)",
      acceptedDocumentsFormats: 'PDF, JPG, PNG',
      acceptedDocumentsFormatsLabel: "Akzeptierte Formate:",
      acceptedDocumentsMaxSizeLabel: "Maximale Größe pro Datei:",
      acceptedDocumentsFilesNote: "Sie können die beiden Dateien für den jeweiligen Dokumenttyp hochladen.",
      powerConsentBefore: 'Ich willige ausdrücklich in die Aktivierung einer digitalen Vollmacht gemäß den Bedingungen, die eingesehen werden können ',
      powerConsentHere: 'hier',
      powerTitle: 'Digitale Vollmacht aktivieren',
      powerDescription: 'Wir werden eine digitale Vollmacht zugunsten von EJEMPLO ausstellen, um die erforderliche Dokumentation für Finanzierungsanträge zu erhalten. Um Ihre Informationen zu aktualisieren, werden wir Sie immer erneut um Ihre Zustimmung bitten.',
      powerAcceptSign: 'Ich akzeptiere und signiere das Dokument digital',
      powerTcTitle: 'EINE DIGITALE VOLLMACHT ERTEILEN, UM DOKUMENTATION AUTOMATISCH ZU ERHALTEN',
      requestAgainIn: 'Erneut anfragen in',
      seconds: 'Sekunden',
      status: 'Status',
      createNewRequest: 'Neue Anfrage erstellen',
      noAutofirmaHint: 'Wenn du <strong>Autofirma</strong> nicht installiert hast, verwende den folgenden Link, um <a href="https://firmaelectronica.gob.es/Home/Descargas.html" class="text-blue-500 font-bold underline" target="_blank">Autofirma zu installieren</a>',
      password: {
        label: 'Passwort',
        confirmLabel: 'Passwort wiederholen',
        required: 'Passwort ist erforderlich',
        minLength: 'Das Passwort muss mindestens 8 Zeichen lang sein',
        confirmRequired: 'Du musst das Passwort wiederholen',
        mismatch: 'Die Passwörter müssen übereinstimmen',
        save: 'Speichern',
      },
      autofirma: {
        signedFileLoaded: 'Signierte Datei hochgeladen',
        signCertificate: 'Zertifikat signieren',
        waitingAutofirma: 'Warte auf Autofirma...',
        noDocument: 'Kein Dokument zum Senden vorhanden.',
        prepareError: 'Dokument konnte nicht vorbereitet werden: ',
        notFoundTitle: 'Autofirma nicht gefunden',
        notFoundMessage: 'Wir haben Autofirma nicht auf deinem Gerät installiert erkannt. Bitte verwende den folgenden Link, um es herunterzuladen, und versuche es erneut.',
        timeoutMessage: 'Keine Antwort von Autofirma erhalten. Überprüfe, ob die Anwendung installiert ist und der Browser sie öffnen kann, und versuche es erneut. Wenn du sie noch nicht hast, kannst du sie vom folgenden Link herunterladen.',
        downloadAutofirma: 'Autofirma herunterladen',
        cancel: 'Abbrechen',
        unknownError: 'Unbekannter Fehler',
        errorOccurred: 'Ein Fehler ist aufgetreten: ',
      },
      errors: {
        readServiceTerms: 'Du musst die Service-AGB lesen',
        readCertTerms: 'Du musst die Geschäftsbedingungen für die Zertifikatausstellung lesen',
        acceptServiceTerms: 'Du musst die Service-AGB akzeptieren',
        acceptSecurityPolicy: 'Du musst die Sicherheitsrichtlinie akzeptieren',
        acceptCertTerms: 'Du musst die Geschäftsbedingungen für die Zertifikatausstellung akzeptieren',
        acceptLegalCheck: 'Du musst die rechtliche Checkbox akzeptieren',
        consentPowerActivation: 'Du musst der Aktivierung einer digitalen Vollmacht zustimmen, die im REA registriert ist',
      },
      loadings: {
        gettingRequestInfo: 'Antragsinformationen werden abgerufen',
        uploadingDocs: 'Dokumentation wird hochgeladen...',
        sendingInfo: 'Informationen werden gesendet...',
        startingEmission: 'Zertifikatausstellungsprozess wird gestartet...',
        validatingInfo: 'Informationen werden validiert, bitte warten...',
        sendingOtp: 'OTP-Code wird gesendet...',
        processingRequest: 'Wir verarbeiten deinen Antrag. Bitte einen Moment warten',
      },
      requestRetry: {
        title: 'Antragsfehler',
        description: 'Dieser Antrag ist ausgesetzt und wurde durch einen neueren ersetzt. Wenn du möchtest, kannst du den Ablauf mit diesem Antrag fortsetzen, indem du auf die Schaltfläche unten klickst',
        continueFlow: 'Ablauf fortsetzen',
      },
      requisites: {
        haveFde: 'Ich habe FDE installiert, weiter',
        noFde: 'Ich habe FDE nicht installiert, installieren',
        downloadStore: 'Aus dem Microsoft Store herunterladen',
        fdeOpened: 'FDE ist geöffnet, weiter',
      },
    },
    loadings: {
      gettingData: 'Antragsdaten werden abgerufen...',
      resendingOtp: 'OTP wird erneut gesendet...',
      sendingData: 'Daten werden gesendet...',
      validatingData: 'Neue Daten werden validiert, bitte warten...',
      validatingAndLoginSS: 'Daten werden validiert und bei der Sozialversicherung angemeldet, bitte warten...',
      validatingAndLoginAEAT: 'Daten werden validiert und bei der AEAT angemeldet, bitte warten...',
      resendingRequest: 'Anfrage wird erneut gesendet...',
      smsToPin: 'Es wurde eine falsche Telefonnummer erkannt, wir versuchen es über den Clave-PIN-Fluss',
      sendingNewPhone: 'Neue Telefonnummer wird gesendet, bitte warten',
      validatingRequest: 'Anfrage wird validiert, bitte warten...',
      creatingRequest: 'Anfrage wird erstellt, bitte warten',
      cancelingRequest: 'Anfrage wird storniert...',
      checkingSms: 'SMS-Dienst wird überprüft...',
      loadingDocs: 'Dokumente werden geladen',
      autoUploadTitle: 'Automatischer Dokumentenupload',
    },
    actions: {
      continue: 'Weiter',
      cancel: 'Prozess abbrechen',
      back: 'Zurück',
      send: 'Senden',
      retry: 'Erneut versuchen',
      resend: 'Erneut senden',
      next: 'Weiter',
      clickToFinish: 'Hier klicken, um abzuschließen',
      newRequest: 'Neue Anfrage',
      gotoCurrentRequest: 'Zur aktuellen Anfrage',
      uploadFiles: 'Dateien hochladen',
    },
    otp: {
      requestingOtp: 'Wir fordern den Code an. Bitte einen Moment warten.',
      otpSentToNumber: 'Der Code wurde an die Telefonnummer gesendet, die endet auf',
      requestingCode: 'Wir fordern den Code an. Bitte einen Moment warten.',
      noReceivedCode: 'Hast du den Code nicht auf deinem Telefon erhalten?',
      noReceivedCode2: 'Hast du den Code nicht auf dem Telefon erhalten, das endet auf',
      otpCode: 'OTP-Code (per SMS erhalten)',
    },
    flowCommon: {
      certTermsBefore: 'Ich habe die',
      certTermsLink: 'Geschäftsbedingungen',
      certTermsAfter: 'gelesen und akzeptiere sie für die Ausstellung des Zertifikats',
      loadingData: 'Daten werden geladen..',
      sendingPassword: 'Passwort wird gesendet..',
      personType: 'Personenart',
      natural: 'Natürliche Person',
      legal: 'Juristische Person',
      name: 'Name',
      firstSurname: 'Vorname',
      secondSurname: 'Zweiter Vorname',
      emailPlaceholder: 'z.B. mi_email@dominio.com',
      phonePlaceholder: 'z.B. 123123123',
      dniPlaceholderShort: 'z.B. 2222221R',
      cifPlaceholderShort: 'z.B. 123123123',
    },
    videoid: {
      waitingVideoId: 'Warte auf Video-ID-Validierung',
      redirectingVintegris: 'Weiterleitung zu Vintegris, bitte warten...',
      sendingPassword: 'Passwort wird gesendet...',
      sendingOtpShort: 'OTP wird gesendet...',
      invalidOtpRetry: 'Der eingegebene Code ist falsch. Bitte versuche es erneut',
    },
  }
}
